




// // import { useEffect, useMemo, useState } from "react";
// // import VendorHotels from "./VendorHotels";
// // import HotelDashboard from "./Hoteldashboard";
// // import VendorCabs from "./VendorCabs";
// // import VendorCabDrivers from "./VendorCabDrivers";
// // import CabVendorDashboard from "./CabVendorDashboard";
// // import BusModule from "./BusModule";
// // import BusTripModule from "./BusTripModule";
// // import BusSeatLayoutModule from "./BusSeatLayoutModule";
// // import VendorBusBookings from "./VendorBusBookings";
// // import VendorCabBookings from "./VendorCabBookings";
// // import VendorHotelBookings from "./VendorHotelBookings";
// // import VendorHotelRooms from "./Vendorhotelrooms";
// // import VendorRoomInventory from "./Vendorroominventory";
// // import VillaManager from "../pages/villa/VillaManager";
// // import VillaRoomManager from "./villa/VillaRoomManager";
// // import Villaroominventory from "../pages/villa/Villaroominventory";
// // import Villaroompricing from "../pages/villa/Villaroompricing";
// // import VillaBookings from "./villa/Villabooking";
// // import VendorApartment from "./Vendorapartment";
// // import VendorApartmentInventory from "../pages/Apartment/Vendorapartmentinventory";
// // import VendorHomestay from "./VendorHomestay";
// // import Homestayunitmanager from "./Homestayunitmanager";
// // import VendorHomestayInventory from "./VendorHomestayInventory";
// // import HomestayDashboard from "./Homestaydashboard";
// // import VendorHomestayBookings from "./VendorHomestayBookings";
// // import AddDarshan from "./darshan/AddDarshan";
// // import Darshantype from "./darshan/Darshantype";
// // import Darshanslot from "./darshan/Darshanslot";
// // import Darshanavailability from "./darshan/Darshanavailability";
// // import DarshanBookings from "./darshan/Vendordarshanbookings";
// // import VendorHoliday from "./VendorHoliday";
// // import VendorHolidayBookings from "./VendorHolidayBookings";
// // import VendorBnb from "./Bnbmanager";
// // import Palaceapp from "./Palaceapp";
// // import AddPlace from "./Place/addPlace";
// // import PalaceRoomCategories from "../pages/Place/PalaceRoomCategories";
// // import PalaceAnalytics from "./Place/PalaceAnalytics";
// // import PalaceRoomUnits from "./Place/PalaceRoomUnits";
// // import PalaceInventory from "./Place/PalaceInventory";
// // import PalaceRatePlans from "./Place/PalaceRatePlans";
// // import PalaceBookings from "./Place/PalaceBookings";
// // import VendorRatingsReviews from "../pages/VendorRatingsReviews";
// // import VendorOffers from "../pages/Place/VendorOffers";
// // import VendorAdvertisements from "../pages/Place/VendorAdvertisements";
// // import VendorVacationHouse from "./Vacationhouseapp";
// // import NightclubManagement from "./NightClub/NightclubManagement";
// // import NightclubTables from "./NightClub/Nightclubtables";
// // import NightclubTablePricing from "./NightClub/Nightclubtablepricing";
// // import ManageEvents from "./NightClub/ManageEvents";
// // import EventTickets from "./NightClub/EventTickets";
// // import { BnbBooking } from "./bnbBooking/BnbBooking";
// // import VendorProfile from "./VendorProfile";
// // import VendorSupport from "../pages/Place/VendorSupport";
// // import VendorPolicies from "../pages/Place/VendorPolicies";
// // import VendorCruise from "./VendorCruise";
// // import CabinManagement from "./CabinManagement";
// // import CruiseItineraryManagement from "./CruiseItineraryManagement";
// // import CruiseSailingManagement from "./CruiseSailingManagement";
// // import Tours from "./tours-activities/Tours";
// // import TourBookings from "./tours-activities/Tourbookings";

// // import TourQuery from "./tours-activities/TourQuery";
// // import TourReview from "./tours-activities/TourReview";
// // import TourSchedule from "./tours-activities/TourSchedule";
// // import AddActivities from "./Activities/AddActivities";
// // import ScheduleActivities from "./Activities/ScheduleActivities";
// // import ActivitiesBookings from "./Activities/ActivitiesBookings";
// // import AddResort from "./Resort/addResort";
// // import ResortRooms from "./Resort/Resortrooms";
// // import ResortRoomUnits from "./Resort/ResortRoomUnits";
// // import ResortPricing from "./Resort/Resortpricing";
// // import ResortInventory from "./Resort/Resortinventory";
// // import ResortBookings from "./Resort/Resortbookings";
// // import ResortReviews from "./Resort/Resortreviews";
// // import "./VendorCruise.css";
// // import "./VendorLayout.css";

// // /* ==================== ICONS & MENU HELPERS ==================== */

// // const IC = {
// //   dash: "▦", book: "▤", inv: "▥", prop: "⌂", bed: "▭", img: "▧", star: "☆", pin: "⌖", doc: "▢",
// //   chart: "⌁", ship: "⚓", map: "◫", plus: "＋", price: "$", car: "◉", user: "☺", bus: "▣", seat: "▤",
// //   tour: "✈", ev: "◆", club: "♪", pray: "◇", gear: "⚙", crown: "♛",
// //   grow: "✦", pay: "◈", ad: "AD", eye: "◎", camp: "✦",
// // };
// // const L = (list) => list.map(([id, label, icon]) => ({ id, label, icon: IC[icon] }));

// // const D = ["dashboard", "Dashboard", "dash"];

// // // Property information tail (Hotel / Homestay)
// // const stayTail = [
// //   // ["property_media", "Images & Videos", "img"],
// //   // ["property_amenities", "Amenities & Facilities", "star"],
// //   // ["property_location", "Location & Contact", "pin"],
// //   // ["property_policies", "Policies & House Rules", "doc"],
// //   // ["property_documents", "Documents & Verification", "doc"],
// //   // ["property_highlights", "Highlights & USPs", "star"],
// //   // ["ratings_reviews", "Ratings & Reviews", "star"],
// //   // ["palace_analytics", "Analytics", "chart"],
// // ];

// // // Hotel-only "Grow your business" + payments + sponsored
// // const hotelGrow = [
// //   // ["promotions", "Promotions & Offers", "grow"],
// //   // ["visibility_boost", "Visibility Booster", "eye"],
// //   // ["campaigns", "Campaigns", "camp"],
// //   // ["payments", "Payments", "pay"],
// //   // ["sponsored", "Sponsored Listing", "ad"],
// // ];

// // /* ==================== PANELS (per vendor vertical) ==================== */

// // const PANELS = {
// //   hotel: {
// //     title: "Hotel",
// //     icon: IC.prop,
// //     main: L([
// //       D,
// //       ["hotels_bookings", "Bookings", "book"],
// //       ["hotel_room_inventory", "Rates & Inventory", "inv"],
// //       ...hotelGrow,
// //       ["hotels_manage", "Property Details", "prop"],
// //       ["hotel_rooms", "Rooms & Units", "bed"],
// //       ...stayTail,
// //     ]),
// //   },
// //   homestay: {
// //     title: "Homestay",
// //     icon: IC.prop,
// //     main: L([
// //       D,
// //       ["homestays_bookings", "Bookings", "book"],
// //       ["homestay_inventory", "Rates & Inventory", "inv"],
// //       ["homestays_manage", "Property Details", "prop"],
// //       ["homestay_units", "Units / Rooms", "bed"],
// //       ...stayTail,
// //     ]),
// //   },
// //   resort: {
// //     title: "Resort",
// //     icon: IC.prop,
// //     main: L([
// //       D,
// //       ["resort_manage", "My Resorts", "prop"],
// //       ["resort_rooms", "Rooms & Categories", "bed"],
// //       ["resort_bookings", "Bookings", "book"],
// //       ["resort_units", "Room Units", "seat"],
// //       // ["resort_reviews", "Ratings & Reviews", "star"],
// //       ["resort_inventory", "Availability", "inv"],
// //       ["resort_pricing", "Rates & Pricing", "inv"],
// //       ["analytics", "Analytics", "chart"],
// //     ]),
// //   },
// //   cruise: {
// //     title: "Cruise",
// //     icon: IC.ship,
// //     main: L([
// //       D,
// //       ["cruise_manage", "My Cruises", "ship"],
// //       ["cruise_cabins", "Cabin Management", "bed"],
// //       ["cruise_itineraries", "Itinerary Management", "map"],
// //       ["cruise_sailings", "Sailing Management", "ship"],
// //       ["cruise_pricing", "Pricing Management", "price"],
// //       ["cruise_add", "Add Cruise", "plus"],
// //       ["cruise_bookings", "Bookings", "book"],
// //     ]),
// //   },
// //   cab: {
// //     title: "Cab",
// //     icon: IC.car,
// //     main: L([
// //       D,
// //       ["cabs_manage", "Manage Cabs", "car"],
// //       ["cabs_drivers", "Driver Management", "user"],
// //       ["cabs_bookings", "Cab Bookings", "book"],
// //     ]),
// //   },
// //   bus: {
// //     title: "Bus",
// //     icon: IC.bus,
// //     main: L([
// //       D,
// //       ["buses_manage", "Manage Buses", "bus"],
// //       ["bus_trip_module", "Trip Management", "map"],
// //       ["bus_seat_layout", "Seat Layout", "seat"],
// //       ["buses_bookings", "Bus Bookings", "book"],
// //     ]),
// //   },
// //   tours: {
// //     title: "Tours",
// //     icon: IC.tour,
// //     main: L([
// //       D,
// //       ["tours_manage", "Manage Tours", "tour"],
// //       ["tours_bookings", "Tour Bookings", "book"],
// //       ["tours_queries", "Tour Queries", "doc"],
// //       ["tours_reviews", "Tour Reviews", "star"],
// //       ["tours_schedule", "Tour Schedules", "map"],
// //     ]),
// //   },
// //   activities: {
// //     title: "Activities",
// //     icon: IC.ev,
// //     main: L([
// //       D,
// //       ["activities_manage", "Manage Activities", "ev"],
// //       ["activities_schedule", "Activity Schedules", "map"],
// //       ["activities_bookings", "Activity Bookings", "book"],
// //     ]),
// //   },
// //   events: {
// //     title: "Events",
// //     icon: IC.ev,
// //     main: L([
// //       D,
// //       ["events_manage", "Manage Events", "ev"],
// //       ["events_tickets", "Event Tickets", "book"],
// //       ["events_nightclub", "Night Club", "club"],
// //       ["nightclub_tables", "Tables", "seat"],
// //       ["nightclub_table_pricing", "Table Pricing", "price"],
// //       ["events_bookings", "Event Bookings", "book"],
// //     ]),
// //   },
// //   nightclub: {
// //     title: "Night Club",
// //     icon: IC.club,
// //     main: L([
// //       D,
// //       ["nightclub_manage", "Manage Night Club", "club"],
// //       ["nightclub_tables", "Tables", "seat"],
// //       ["nightclub_table_pricing", "Table Pricing", "price"],
// //     ]),
// //   },
// //   darshan: {
// //     title: "Darshan",
// //     icon: IC.pray,
// //     main: L([
// //       D,
// //       ["darshan_add", "Add Darshan", "plus"],
// //       ["darshan_types", "Darshan Types", "tour"],
// //       ["darshan_slots", "Darshan Slots", "seat"],
// //       ["darshan_availability", "Slot Availability", "inv"],
// //       ["darshan_bookings", "Bookings", "book"],
// //     ]),
// //   },
// //   holidays: {
// //     title: "Holidays",
// //     icon: IC.tour,
// //     main: L([D, ["holidays_manage", "Manage Holidays", "tour"], ["holidays_bookings", "Holiday Bookings", "book"]]),
// //   },
// //   bnb: {
// //     title: "BnB",
// //     icon: IC.prop,
// //     main: L([D, ["bnb_manage", "Manage BnB", "prop"], ["bnb_bookings", "BnB Bookings", "book"]]),
// //   },
 

// // palace: {
// //   title: "Palace",
// //   icon: IC.crown,
// //   main: L([
// //     D,
// //     ["palace_manage", "My Palaces", "crown"],
// //     ["palace_room_categories", "Palace Room Categories", "bed"],
// //     ["palace_room_units", "Room Units", "seat"],
// //     ["palace_inventory", "Room Inventory", "inv"],
// //     ["palace_rate_plans", "Rate Plans & Pricing", "price"],
// //     ["palace_bookings", "Palace Bookings", "book"],
// //     ["palace_analytics", "Analytics", "chart"],
    
// //   ]),
// // },


// //   vacation: {
// //     title: "Vacation House",
// //     icon: IC.prop,
// //     main: L([D, ["vacationhouses_manage", "Manage Houses", "prop"], ["vacationhouses_bookings", "Bookings", "book"]]),
// //   },
// //  villa: {
// //   title: "Villa",
// //   icon: IC.prop,
// //   main: L([
// //     D,
// //     ["villa_manage", "Manage Villas", "prop"],
// //     ["villa_rooms", "Villa Rooms", "bed"],
// //     ["villa_inventory", "Room Inventory", "inv"],
// //     ["villa_pricing", "Room Pricing", "inv"],
// //     ["villa_bookings", "Villa Bookings", "book"],
// //   ]),
// // },
// //  apartments: {
// //   title: "Apartments",
// //   icon: IC.prop,
// //   main: L([
// //     D,
// //     ["apartments_manage", "Manage Apartments", "prop"],
// //     ["apartments_inventory", "Apartment Inventory", "inv"],
// //   ]),
// // },
// //   partner: { title: "Partner", icon: IC.dash, main: L([D]) },
// // };

// // // Account section (all vendors) — full profile sub-sections included
// // const ACCOUNT = L([
// //   ["profile_personal", "My Profile", "user"],
// //   ["profile_business", "Business Details", "prop"],
// //   ["profile_contact", "Contact Details", "pin"],
// //   ["profile_tax", "Tax & Identity", "doc"],
// //   ["profile_bank", "Bank Details", "pay"],
// //   ["profile_service", "Service Details", "gear"],
// //   ["settings", "Settings", "gear"],
// // ]);

// // // Common items shown in every vendor vertical
// // const COMMON_VENDOR_MENU = L([
// //   ["vendor_offers", "Offers & Promotions", "grow"],
// //   ["vendor_advertisements", "Advertisements", "ad"],
// //   ["vendor_support", "Support", "doc"],
// //   ["vendor_ratings_reviews", "Ratings & Reviews", "star"],
// //   ["vendor_policies", "Privacy & Policies", "gear"],
// // ]);

// // /*
// //   vendor.vertical / staySubtype  ->  panel key

// //   Every Stay subtype offered in onboarding must map to a panel,
// //   otherwise the vendor lands on the empty "partner" panel.
// //   Subtypes that have no dedicated panel use the closest existing one
// //   (change the right-hand side if you build a dedicated panel later).
// // */
// // const normalizeService = (value) =>
// //   String(value || "")
// //     .trim()
// //     .toLowerCase()
// //     .replace(/[_\s]+/g, "-")
// //     .replace(/-+/g, "-");

// // const ALIASES = {
// //   // Stay subtypes with their own panel
// //   hotel: "hotel", hotels: "hotel",
// //   homestay: "homestay", homestays: "homestay", "home-stay": "homestay",
// //   resort: "resort", resorts: "resort",
// //   palace: "palace",
// //   bnb: "bnb", "bed-and-breakfast": "bnb", "b-and-b": "bnb", stay: "bnb",
// //   apartment: "apartments", apartments: "apartments",
// //   "vacation-house": "vacation", "vacation-home": "vacation",
// //   vacation: "vacation", vacationhouse: "vacation",
// //   villa: "villa", villas: "villa",

// //   // Stay subtypes using the closest existing panel
// //   guesthouse: "homestay", "guest-house": "homestay",
// //   hostel: "homestay", farmhouse: "homestay", "farm-stay": "homestay",
// //   camp: "homestay", campsite: "homestay", "camp-site": "homestay",
// //   motel: "hotel", lodge: "hotel", inn: "hotel",
// //   "serviced-apartment": "apartments",

// //   // Other verticals
// //   cab: "cab", cabs: "cab", "car-rental": "cab",
// //   bus: "bus", buses: "bus",
// //   cruise: "cruise", cruises: "cruise",
// //   package: "tours", packages: "tours", tours: "tours", tour: "tours",
// //   activity: "activities", activities: "activities",
// //   events: "events", event: "events",
// //   darshan: "darshan", darshans: "darshan", "bmt-darshan": "darshan",
// //   holiday: "holidays", holidays: "holidays",
// //   nightclub: "nightclub", nightclubs: "nightclub", "night-club": "nightclub",
// // };

// // /* ==================== SIMPLE (placeholder) PAGES ==================== */
// // /* NOTE: yahan jo tab id hoga wo PAGES se PEHLE render hota hai.
// //    Isliye activities_*, darshan_*, nightclub_*, palace_* yahan NAHI hone chahiye
// //    (ye real pages hain). */

// // const SIMPLE_PAGES = {
// //   promotions: ["Promotions & Offers", "Create property discounts, mobile offers, early-bird offers and limited-time deals."],
// //   visibility_boost: ["Visibility Booster", "Improve property visibility with sponsored placement and performance campaigns."],
// //   campaigns: ["Campaigns", "Manage seasonal campaigns and marketing participation."],
// //   payments: ["Payments", "View settlements, payment status, deductions and payout history."],
// //   sponsored: ["Sponsored Listing", "Boost your property ranking through paid sponsored placement."],
// //   ratings_reviews: ["Ratings & Reviews", "Track guest ratings, review reasons and respond to guest feedback."],
// //   events_bookings: ["Event Bookings", "View and manage bookings received for your events."],
// //   vacationhouses_bookings: ["Vacation House Bookings", "Manage upcoming, completed and cancelled reservations."],
// //   // villa_manage: ["Manage Villas", "Manage your villa property details, photos, amenities and listing information."],
// //   // villa_bookings: ["Villa Bookings", "Manage upcoming, completed and cancelled villa reservations."],
// //   cruise_pricing: ["Pricing Management", "Set cabin prices and seasonal rates for your sailings."],
// //   cruise_bookings: ["Cruise Bookings", "View and manage bookings received for your sailings."],
// //   settings: ["Settings", "Manage your account preferences."],
// // };

// // const PROFILE_SECTIONS = {
// //   profile_personal: "personal",
// //   profile_business: "business",
// //   profile_contact: "contact",
// //   profile_tax: "tax",
// //   profile_bank: "bank",
// //   profile_service: "service",
// // };

// // /* ==================== TAB -> PAGE MAP ==================== */

// // const PAGES = {
// //   // Common pages available to every vendor dashboard
// //   vendor_offers: <VendorOffers />,
// //   vendor_advertisements: <VendorAdvertisements />,
// //   vendor_support: <VendorSupport />,
// //   vendor_policies: <VendorPolicies />,
// //   // Hotel
// //   hotels_manage: <VendorHotels />,
// //   hotel_rooms: <VendorHotelRooms />,
// //   hotel_room_inventory: <VendorRoomInventory />,
// //   hotels_bookings: <VendorHotelBookings />,
// //   // Homestay
// //   homestays_manage: <VendorHomestay />,
// //   homestay_units: <Homestayunitmanager />,
// //   homestay_inventory: <VendorHomestayInventory />,
// //   homestays_bookings: <VendorHomestayBookings />,
// //   // Resort
// //   resort_manage: <AddResort />,
// //   resort_rooms: <ResortRooms />,
// //   resort_units: <ResortRoomUnits />,
// //   resort_pricing: <ResortPricing />,
// //   resort_bookings: <ResortBookings />,
// //   resort_reviews: <ResortReviews />,
// //   resort_inventory: <ResortInventory />,
// //   // Property info (shared)
// //   property_media: <PropertyMedia />,
// //   property_amenities: <PropertyAmenities />,
// //   property_location: <PropertyLocation />,
// //   property_policies: <PropertyPolicies />,
// //   property_documents: <PropertyDocuments />,
// //   property_highlights: <PropertyHighlights />,
// //   analytics: <AnalyticsPage />,
// //   // BnB / Apartments
// //   bnb_manage: <VendorBnb />,
// //   bnb_bookings: <BnbBooking />,
// //   apartments_manage: <VendorApartment />,
  
// //   // Cab
// //   cabs_manage: <VendorCabs />,
// //   cabs_drivers: <VendorCabDrivers />,
// //   cabs_bookings: <VendorCabBookings />,
// //   // Bus
// //   buses_manage: <BusModule />,
// //   bus_trip_module: <BusTripModule />,
// //   bus_seat_layout: <BusSeatLayoutModule />,
// //   buses_bookings: <VendorBusBookings />,
// //   // Cruise
// //   cruise_manage: <VendorCruise />,
// //   cruise_add: <VendorCruise />,
// //   cruise_cabins: <CabinManagement />,
// //   cruise_itineraries: <CruiseItineraryManagement />,
// //   cruise_sailings: <CruiseSailingManagement />,
// //   // Tours
// //   tours_manage: <Tours />,
// //   tours_bookings: <TourBookings />,
// //   tours_queries: <TourQuery />,
// //   tours_reviews: <TourReview />,
// //   tours_schedule: <TourSchedule />,
// //   // Activities
// //   activities_manage: <AddActivities />,
// //   activities_schedule: <ScheduleActivities />,
// //   activities_bookings: <ActivitiesBookings />,
// //   // Events / Night club
// //   events_manage: <ManageEvents />,
// //   events_tickets: <EventTickets />,
// //   nightclub_manage: <NightclubManagement />,
// //   events_nightclub: <NightclubManagement />,
// //   nightclub_tables: <NightclubTables />,
// //   nightclub_table_pricing: <NightclubTablePricing />,
// //   // Darshan
// //   darshan_add: <AddDarshan />,
// //   darshan_types: <Darshantype />,
// //   darshan_slots: <Darshanslot />,
// //   darshan_availability: <Darshanavailability />,
// //   darshan_bookings: <DarshanBookings />,
 
// // // villa
// // villa_rooms: <VillaRoomManager />,
// // villa_inventory: <Villaroominventory />,
// // villa_pricing: <Villaroompricing />,
// // villa_bookings: <VillaBookings />,
// //   // Palace
// //   palace_manage: <AddPlace />,
// //   palace_rooms: <Palaceapp />,
// //  palace_room_categories: <PalaceRoomCategories />,
// // palace_room_units: <PalaceRoomUnits />,
// // palace_inventory: <PalaceInventory />,
// // palace_rate_plans: <PalaceRatePlans />,
// // palace_bookings: <PalaceBookings />,
// // palace_analytics: <PalaceAnalytics />,
  
// //   // Others
// //   vacationhouses_manage: <VendorVacationHouse />,
// //   holidays_manage: <VendorHoliday />,
// //   holidays_bookings: <VendorHolidayBookings />,


// //   vendor_ratings_reviews: <VendorRatingsReviews />, 

// //   // Others
// // vacationhouses_manage: <VendorVacationHouse />,
// // villa_manage: <VillaManager />,
// // villa_rooms: <VillaRoomManager />,
// // holidays_manage: <VendorHoliday />,
// // holidays_bookings: <VendorHolidayBookings />,

// // vendor_ratings_reviews: <VendorRatingsReviews />,
// // };

// // /* ==================== DASHBOARD SHORTCUTS (per panel) ==================== */

// // const STAY_PANELS = ["hotel", "homestay", "resort", "bnb", "palace", "vacation", "villa", "apartments"];

// // const BOOKING_TARGET = {
// //   hotel: "hotels_bookings",
// //   homestay: "homestays_bookings",
// //   resort: "resort_bookings",
// //   bnb: "bnb_bookings",
// //   vacation: "vacationhouses_bookings",
// //   villa: "villa_bookings",
// //   palace: "palace_manage",
// //   apartments: "apartments_manage",
// //   bus: "buses_bookings",
// //   cab: "cabs_bookings",
// //   activities: "activities_bookings",
// //   darshan: "darshan_bookings",
// //   tours: "tours_bookings",
// //   holidays: "holidays_bookings",
// //   cruise: "cruise_bookings",
// //   events: "events_tickets",
// //   nightclub: "nightclub_manage",
// // };

// // const INVENTORY_TARGET = {
// //   hotel: "hotel_room_inventory",
// //   homestay: "homestay_inventory",
// //   resort: "resort_inventory",
// //   palace: "palace_rooms",
// //   villa: "villa_manage",
// //   activities: "activities_schedule",
// //   darshan: "darshan_availability",
// //   nightclub: "nightclub_table_pricing",
// //   tours: "tours_schedule",
// //   bus: "bus_trip_module",
// //   cab: "cabs_manage",
// //   cruise: "cruise_sailings",
// // };

// // const SETUP_ACTIONS = {
// //   resort: [
// //     ["resort_manage", "Add or Edit Resorts"],
// //     ["resort_rooms", "Add Room Categories & Prices"],
// //     ["resort_manage", "Review Policies & Check-in Times"],
// //     ["resort_units", "Add Room Numbers (Units)"],
// //     ["resort_pricing", "Set Rate Plans & Date Prices"],
// //   ],
// //   palace: [
// //     ["palace_manage", "Add or Edit Palaces"],
// //     ["palace_manage", "Upload Gallery & Set Cover Image"],
// //     ["palace_manage", "Review Policies & Check-in Times"],
// //     ["palace_rooms", "Add Rooms, Rates & Inventory"],
// //   ],
// //   default: [
// //     ["property_media", "Add Images & Videos"],
// //     ["property_amenities", "Update Amenities & Facilities"],
// //     ["property_policies", "Review Property Policies"],
// //   ],
// // };

// // /* ==================== HELPERS ==================== */

// // const pathTab = () => {
// //   const p = typeof window !== "undefined" ? window.location.pathname : "";
// //   if (p.includes("/vendor/cab/driver") || p.includes("/vendor/cab-driver")) return "cabs_drivers";
// //   if (p.includes("/vendor/cab/booking")) return "cabs_bookings";
// //   if (p.includes("/vendor/cab/manage")) return "cabs_manage";
// //   if (p.includes("/vendor/darshan/add")) return "darshan_add";
// //   if (p.includes("/vendor/darshan/types")) return "darshan_types";
// //   if (p.includes("/vendor/darshan/slots")) return "darshan_slots";
// //   if (p.includes("/vendor/darshan/availability")) return "darshan_availability";
// //   if (p.includes("/vendor/darshan/bookings")) return "darshan_bookings";
// //   if (p.includes("/vendor/nightclub/pricing")) return "nightclub_table_pricing";
// //   if (p.includes("/vendor/nightclub/tables")) return "nightclub_tables";
// //   return "";
// // };

// // const clearSession = () => {
// //   localStorage.removeItem("vendorToken");
// //   localStorage.removeItem("vendorUser");
// //   sessionStorage.removeItem("bmtVendorActiveTab");
// // };

// // /* ==================== MAIN LAYOUT ==================== */

// // export default function VendorLayout() {
// //   const [activeTab, setActiveTab] = useState(() => pathTab() || sessionStorage.getItem("bmtVendorActiveTab") || "dashboard");
// //   const [accountOpen, setAccountOpen] = useState(() =>
// //   String(
// //     pathTab() ||
// //     sessionStorage.getItem("bmtVendorActiveTab") ||
// //     "dashboard"
// //   ).startsWith("profile_")
// // );
// //   const [vendorName, setVendorName] = useState("");
// //   const [vendorService, setVendorService] = useState("");
// //   const [loading, setLoading] = useState(true);

// //   // Session check + vendor info
// //   useEffect(() => {
// //     const token = localStorage.getItem("vendorToken");
// //     const stored = localStorage.getItem("vendorUser");
// //     if (!token || !stored) {
// //       clearSession();
// //       window.location.href = "/vendor-login";
// //       return;
// //     }
// //     try {
// //       const vendor = JSON.parse(stored);
// //       const vertical = normalizeService(vendor.vertical || vendor.selectedVertical || "");
// //       const staySubtype = normalizeService(
// //         vendor.staySubtype ||
// //           vendor.business?.staySubtype ||
// //           vendor.business?.service ||
// //           vendor.business?.propertyType ||
// //           vendor.propertyType ||
// //           (vertical === "stay" ? vendor.service : "") ||
// //           ""
// //       );
// //       setVendorName(
// //         vendor.business?.businessName ||
// //           vendor.businessName ||
// //           vendor.companyName ||
// //           vendor.name ||
// //           vendor.ownerName ||
// //           vendor.email ||
// //           "Vendor"
// //       );
// //       // If backend stores the broad vertical as "stay", resolve the selected
// //       // property subtype. If it stores "villa" or another subtype as vertical,
// //       // keep that subtype instead of accidentally routing it to another panel.
// //       const resolvedService = vertical === "stay" ? (staySubtype || "stay") : vertical;
// //       setVendorService(resolvedService);

// //       // Cruise vendors should not land on a profile tab from a stale session
// //       if (resolvedService === "cruise" && String(activeTab).startsWith("profile_")) {
// //         setActiveTab("cruise_manage");
// //         sessionStorage.setItem("bmtVendorActiveTab", "cruise_manage");
// //       }
// //     } catch (error) {
// //       console.error("VENDOR SESSION ERROR:", error);
// //       clearSession();
// //       window.location.href = "/vendor-login";
// //       return;
// //     } finally {
// //       setLoading(false);
// //     }
// //     // eslint-disable-next-line react-hooks/exhaustive-deps
// //   }, []);

// //   const key = ALIASES[normalizeService(vendorService)] || "partner";
// //   const panel = PANELS[key];

// //   const allIds = useMemo(
// //     () =>
// //       new Set(
// //         [...panel.main, ...ACCOUNT, ...COMMON_VENDOR_MENU]
// //           .map((item) => item.id)
// //           .concat(Object.keys(PROFILE_SECTIONS))
// //       ),
// //     [panel]
// //   );
// //   const tab = allIds.has(activeTab) ? activeTab : "dashboard";

// //   useEffect(() => {
// //     sessionStorage.setItem("bmtVendorActiveTab", tab);
// //   }, [tab]);

// //   const logout = () => {
// //     if (window.confirm("Are you sure you want to logout?")) {
// //       clearSession();
// //       window.location.href = "/vendor-login";
// //     }
// //   };

// //   // const renderContent = () => {
// //   //   if (tab === "dashboard") {
// //   //     return key === "cab"
// //   //       ? <CabVendorDashboard onNavigate={setActiveTab} />
// //   //       : <DashboardContent panelKey={key} onNavigate={setActiveTab} />;
// //   //   }
// //   //   if (PROFILE_SECTIONS[tab]) return <VendorProfile initialSection={PROFILE_SECTIONS[tab]} />;
// //   //   if (SIMPLE_PAGES[tab]) return <SimplePremiumPage title={SIMPLE_PAGES[tab][0]} description={SIMPLE_PAGES[tab][1]} />;
// //   //   return PAGES[tab] || <DashboardContent panelKey={key} onNavigate={setActiveTab} />;
// //   // };
// //   const renderContent = () => {
// //   // 1. Dashboard: har vendor type ka apna dashboard
// //   if (tab === "dashboard") {
// //     switch (key) {
// //       case "cab":
// //         return <CabVendorDashboard onNavigate={setActiveTab} />;
        
// //       case "homestay":
// //         return <HomestayDashboard onNavigate={setActiveTab} />;
// //       default:
// //         return <DashboardContent panelKey={key} onNavigate={setActiveTab} />;
// //     }
// //   }

// //   // 2. Profile ke sub-sections (personal, business, bank...)
// //   if (PROFILE_SECTIONS[tab]) {
// //     return <VendorProfile initialSection={PROFILE_SECTIONS[tab]} />;
// //   }

// //   // 3. Placeholder pages (jinka backend abhi connected nahi hai)
// //   if (SIMPLE_PAGES[tab]) {
// //     const [title, description] = SIMPLE_PAGES[tab];
// //     return <SimplePremiumPage title={title} description={description} />;
// //   }

// //   // 4. Real pages, warna dashboard par wapas
// //   return PAGES[tab] || <DashboardContent panelKey={key} onNavigate={setActiveTab} />;
// // };

// //   if (loading) {
// //     return (
// //       <div className="bmt-loader">
// //         <div className="bmt-loader-ring" />
// //         <p>Loading BirdMyTrip Partner Panel...</p>
// //       </div>
// //     );
// //   }

// //   const NavButton = ({ item }) => (
// //     <button
// //       className={`vx-item ${tab === item.id ? "active" : ""}`}
// //       onClick={() => setActiveTab(item.id)}
// //       title={item.label}
// //     >
// //       <span className="vx-icon">{item.icon}</span>
// //       <span className="vx-label">{item.label}</span>
// //     </button>
// //   );

// //   return (
// //     <div className="vx-app">
// //       <div className="vx-side">
// //         <div className="vx-brand-box">
// //           <div className="vx-brandmark">{panel.icon}</div>
// //           <div className="vx-brand-title"><strong>{panel.title}</strong><span>Vendor</span></div>
// //         </div>

// //         <div className="vx-nav">
// //           <div className="vx-section">Main menu</div>
// //           {panel.main.map((item) => <NavButton key={item.id} item={item} />)}

// //           <div className="vx-section">Help & Legal</div>
// //           {COMMON_VENDOR_MENU.map((item) => (
// //             <NavButton key={item.id} item={item} />
// //           ))}

// //           <div className="vx-section">Account</div>

// // <button
// //   type="button"
// //   className={`vx-item vx-account-toggle ${
// //     String(activeTab).startsWith("profile_") ? "active" : ""
// //   }`}
// //   onClick={() => setAccountOpen((prev) => !prev)}
// //   aria-expanded={accountOpen}
// // >
// //   <span className="vx-icon">{IC.user}</span>
// //   <span className="vx-label">My Profile</span>
// //   <span className={`vx-account-arrow ${accountOpen ? "expanded" : ""}`}>
// //     ›
// //   </span>
// // </button>

// // {accountOpen && (
// //   <div className="vx-account-submenu">
   
// // {ACCOUNT.filter(
// //   (item) =>
// //     item.id.startsWith("profile_") &&
// //     item.id !== "profile_personal"
// // ).map((item) => (
// //   <NavButton key={item.id} item={item} />
// // ))}


// //     {/* {ACCOUNT.filter((item) => item.id === "settings").map((item) => (
// //       <NavButton key={item.id} item={item} />
// //     ))} */}
// //   </div>
// // )}

// //         </div>

// //         <div className="vx-side-foot">
// //           <div className="vx-portal">
// //             <span className="vx-portal-icon">▮</span>
// //             <div><b>Vendor Portal</b><small>Manage your {panel.title.toLowerCase()} business</small></div>
// //           </div>
// //           <button className="vx-logout" onClick={logout}>
// //             <span className="vx-icon">↪</span><span className="vx-label">Logout</span>
// //           </button>
// //         </div>
// //       </div>

// //       <div className="vx-main-wrap">
// //         <div className="vx-top">
// //           <div className="vx-brand">
// //             <div className="vx-logo">bmt</div>
// //             <div className="vx-brand-text">
// //               <strong className="vx-name">{vendorName || "BirdMyTrip Partner"}</strong>
// //               <div className="vx-sub-line"><span className="vx-pill">{panel.title}</span><span>BirdMyTrip Verified Partner</span></div>
// //             </div>
// //           </div>
// //           <div className="vx-top-actions">
// //             <button className="vx-help" aria-label="Help">?</button>
// //             <button className="vx-user" onClick={() => setActiveTab("profile_personal")}>
// //               <span className="vx-avatar">{(vendorName || "V").charAt(0).toUpperCase()}</span>
// //               <span className="vx-user-text"><b>{vendorName || "Vendor"}</b><small>Partner</small></span>
// //             </button>
// //           </div>
// //         </div>

// //         <div className="vx-main">
// //           <div className="vx-content">
// //             {renderContent()}
// //           </div>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // }

// // /* ==================== PAGE COMPONENTS ==================== */

// // function DashboardContent({ panelKey, onNavigate }) {
// //   const isStay = STAY_PANELS.includes(panelKey);
// //   const bookingTarget = BOOKING_TARGET[panelKey] || "dashboard";
// //   const inventoryTarget = INVENTORY_TARGET[panelKey] || "dashboard";
// //   const setupActions = SETUP_ACTIONS[panelKey] || SETUP_ACTIONS.default;

// //   const metrics = isStay ? [
// //     { title: "Today's Room Nights", value: "0", sub: "FOR LAST 7 DAYS : 3 ROOM NIGHTS", action: bookingTarget },
// //     { title: "Today's Revenue", value: "₹ 0", sub: "FOR LAST 7 DAYS : ₹ 3,239", action: bookingTarget },
// //     { title: "Today's Average Selling Price", value: "₹ 0", sub: "FOR LAST 7 DAYS : ₹ 1,371", action: inventoryTarget },
// //     { title: "Today's Check-ins", value: "0", sub: "FOR LAST 7 DAYS : 3 CHECK-INS", action: bookingTarget },
// //   ] : [
// //     { title: "Today's Bookings", value: "0", sub: "FOR LAST 7 DAYS : 12 BOOKINGS", action: bookingTarget },
// //     { title: "Today's Revenue", value: "₹ 0", sub: "FOR LAST 7 DAYS : ₹ 8,920", action: bookingTarget },
// //     { title: "Active Listings", value: "8", sub: "CURRENTLY LIVE ON BIRDMYTRIP", action: inventoryTarget },
// //     { title: "Upcoming Operations", value: "5", sub: "NEXT 7 DAYS", action: bookingTarget },
// //   ];

// //   return (
// //     <div className="bmt-dashboard">
// //       <section className="bmt-performance-head">
// //         <div className="bmt-title-line"><h1>Performance Overview</h1><span className="bmt-info-icon">?</span></div>
// //         <p>Last updated just now</p>
// //       </section>

// //       <section className="bmt-analytics-banner">
// //         <div>
// //           <h2>{isStay ? "Property Analytics" : "Business Analytics"}</h2>
// //           <p>See detailed analysis and past data for Revenue, Room Nights, Average Selling Price, Conversion, Bookings and more.</p>
// //         </div>
// //         <button onClick={() => onNavigate("analytics")}>View All</button>
// //       </section>

// //       <section className="bmt-metrics-grid">
// //         {metrics.map((m) => (
// //           <article className="bmt-metric-card" key={m.title}>
// //             <h3>{m.title}</h3>
// //             <div className="bmt-metric-value">{m.value}</div>
// //             <p>{m.sub}</p>
// //             <button onClick={() => onNavigate(m.action)}>View More</button>
// //           </article>
// //         ))}
// //       </section>

// //       {isStay && (
// //         <section className="bmt-dashboard-bottom-grid">
// //           <article className="bmt-panel-card">
// //             <div className="bmt-card-header">
// //               <div><h3>Property Setup</h3><p>Complete important property content</p></div>
// //               <span className="bmt-new-badge">NEW</span>
// //             </div>
// //             <div className="bmt-action-list">
// //               {setupActions.map(([target, label]) => (
// //                 <button key={`${target}-${label}`} onClick={() => onNavigate(target)}>
// //                   <span>{label}</span><b>›</b>
// //                 </button>
// //               ))}
// //             </div>
// //           </article>
// //           <article className="bmt-panel-card">
// //             <div className="bmt-card-header"><div><h3>Today's Snapshot</h3><p>Quick operational summary</p></div></div>
// //             <div className="bmt-snapshot-grid">
// //               <div><strong>0</strong><span>Pending</span></div>
// //               <div><strong>0</strong><span>Confirmed</span></div>
// //               <div><strong>0</strong><span>Cancelled</span></div>
// //               <div><strong>0</strong><span>Completed</span></div>
// //             </div>
// //           </article>
// //         </section>
// //       )}
// //     </div>
// //   );
// // }

// // function Intro({ eyebrow, title, text, extra }) {
// //   return (
// //     <div className="bmt-section-intro">
// //       <div><span className="bmt-eyebrow">{eyebrow}</span><h2>{title}</h2><p>{text}</p></div>
// //       {extra}
// //     </div>
// //   );
// // }

// // function FormActions({ saveLabel }) {
// //   return (
// //     <div className="bmt-form-actions">
// //       <button className="bmt-secondary-btn">Save Draft</button>
// //       <button className="bmt-primary-btn">{saveLabel}</button>
// //     </div>
// //   );
// // }

// // function PropertyMedia() {
// //   const [images, setImages] = useState([]);
// //   const [videos, setVideos] = useState([]);
// //   const [videoUrl, setVideoUrl] = useState("");
// //   const toItems = (event) =>
// //     Array.from(event.target.files || []).map((file) => ({ file, url: URL.createObjectURL(file), name: file.name }));

// //   return (
// //     <div className="bmt-premium-page">
// //       <Intro
// //         eyebrow="PROPERTY CONTENT"
// //         title="Images & Videos"
// //         text="Add high-quality property photos, room photos, exterior images, facilities, dining images and walkthrough videos."
// //         extra={<span className="bmt-completion-pill">Media completeness 0%</span>}
// //       />
// //       <div className="bmt-property-grid">
// //         <section className="bmt-form-card">
// //           <div className="bmt-form-card-head"><h3>Property Images</h3><p>Recommended: minimum 8 clear landscape photos.</p></div>
// //           <label className="bmt-upload-zone">
// //             <input type="file" accept="image/*" multiple onChange={(e) => setImages((p) => [...p, ...toItems(e)])} />
// //             <span className="bmt-upload-icon">＋</span>
// //             <strong>Upload property images</strong>
// //             <small>JPG, PNG, WEBP • Front view, rooms, lobby, washroom, dining and facilities</small>
// //           </label>
// //           {images.length > 0 && (
// //             <div className="bmt-media-grid">
// //               {images.map((img, i) => (
// //                 <div className="bmt-media-item" key={`${img.name}-${i}`}>
// //                   <img src={img.url} alt={img.name} />
// //                   <button onClick={() => setImages((p) => p.filter((_, x) => x !== i))}>Remove</button>
// //                 </div>
// //               ))}
// //             </div>
// //           )}
// //         </section>

// //         <section className="bmt-form-card">
// //           <div className="bmt-form-card-head"><h3>Property Videos</h3><p>Upload walkthrough videos or add a video URL.</p></div>
// //           <label className="bmt-upload-zone compact">
// //             <input type="file" accept="video/*" multiple onChange={(e) => setVideos((p) => [...p, ...toItems(e)])} />
// //             <span className="bmt-upload-icon">▶</span>
// //             <strong>Upload property video</strong>
// //             <small>MP4 / WEBM recommended</small>
// //           </label>
// //           <div className="bmt-field-group">
// //             <label>Video URL</label>
// //             <div className="bmt-inline-input">
// //               <input value={videoUrl} onChange={(e) => setVideoUrl(e.target.value)} placeholder="https://youtube.com/... or property video URL" />
// //               <button type="button">Add URL</button>
// //             </div>
// //           </div>
// //           {videos.length > 0 && (
// //             <div className="bmt-media-grid video-grid">
// //               {videos.map((v, i) => (
// //                 <div className="bmt-media-item" key={`${v.name}-${i}`}>
// //                   <video src={v.url} controls />
// //                   <button onClick={() => setVideos((p) => p.filter((_, x) => x !== i))}>Remove</button>
// //                 </div>
// //               ))}
// //             </div>
// //           )}
// //         </section>
// //       </div>
// //     </div>
// //   );
// // }

// // function PropertyAmenities() {
// //   const amenities = [
// //     "Free Wi-Fi", "Parking", "Air Conditioning", "Restaurant", "Room Service", "Swimming Pool", "Gym", "Spa",
// //     "Airport Transfer", "24x7 Front Desk", "Power Backup", "Lift / Elevator", "Laundry", "Pet Friendly",
// //     "Wheelchair Accessible", "EV Charging",
// //   ];
// //   const [selected, setSelected] = useState([]);
// //   const toggle = (name) => setSelected((p) => (p.includes(name) ? p.filter((x) => x !== name) : [...p, name]));

// //   return (
// //     <div className="bmt-premium-page">
// //       <Intro eyebrow="PROPERTY INFORMATION" title="Amenities & Facilities" text="Select all facilities available at the property." />
// //       <section className="bmt-form-card">
// //         <div className="bmt-check-grid">
// //           {amenities.map((item) => (
// //             <label className={`bmt-check-card ${selected.includes(item) ? "selected" : ""}`} key={item}>
// //               <input type="checkbox" checked={selected.includes(item)} onChange={() => toggle(item)} />
// //               <span>{item}</span>
// //             </label>
// //           ))}
// //         </div>
// //         <FormActions saveLabel="Save Amenities" />
// //       </section>
// //     </div>
// //   );
// // }

// // function PropertyLocation() {
// //   return (
// //     <div className="bmt-premium-page">
// //       <Intro eyebrow="PROPERTY INFORMATION" title="Location & Contact" text="Keep the exact map location and guest-facing contact details updated." />
// //       <section className="bmt-form-card">
// //         <div className="bmt-form-grid">
// //           <Field label="Address line 1" placeholder="Property address" />
// //           <Field label="Address line 2" placeholder="Area / Landmark" />
// //           <Field label="City" placeholder="City" />
// //           <Field label="State / Province" placeholder="State / Province" />
// //           <Field label="Postal Code" placeholder="Postal code" />
// //           <Field label="Country" placeholder="Country" />
// //           <Field label="Latitude" placeholder="e.g. 27.4924" />
// //           <Field label="Longitude" placeholder="e.g. 77.6737" />
// //           <Field label="Property Phone" placeholder="+91..." />
// //           <Field label="Property Email" placeholder="property@example.com" />
// //         </div>
// //         <div className="bmt-map-placeholder"><span>Map preview</span><small>Connect Google Maps / Mapbox later with your API key.</small></div>
// //         <FormActions saveLabel="Save Location" />
// //       </section>
// //     </div>
// //   );
// // }

// // function PropertyPolicies() {
// //   return (
// //     <div className="bmt-premium-page">
// //       <Intro eyebrow="PROPERTY INFORMATION" title="Policies & House Rules" text="Define check-in, check-out, cancellation, child and guest rules." />
// //       <section className="bmt-form-card">
// //         <div className="bmt-form-grid">
// //           <Field label="Check-in from" type="time" />
// //           <Field label="Check-out until" type="time" />
// //           <SelectField label="Children allowed?" options={["Yes", "No", "On request"]} />
// //           <SelectField label="Pets allowed?" options={["No", "Yes", "On request"]} />
// //           <SelectField label="Smoking" options={["Not allowed", "Designated area only", "Allowed"]} />
// //           <SelectField label="Unmarried couples" options={["Allowed", "Not allowed", "Subject to ID verification"]} />
// //         </div>
// //         <div className="bmt-field-group"><label>Cancellation Policy</label><textarea rows="5" placeholder="Describe cancellation and no-show rules..." /></div>
// //         <div className="bmt-field-group"><label>House Rules</label><textarea rows="5" placeholder="Add important guest rules..." /></div>
// //         <FormActions saveLabel="Save Policies" />
// //       </section>
// //     </div>
// //   );
// // }

// // function PropertyDocuments() {
// //   const docs = ["Business Registration", "Tax Registration", "Property License", "Owner / Authorized ID", "Bank Proof", "Fire / Safety Certificate"];
// //   return (
// //     <div className="bmt-premium-page">
// //       <Intro eyebrow="VERIFICATION" title="Documents & Verification" text="Upload and track documents required to keep your property live." />
// //       <section className="bmt-form-card">
// //         <div className="bmt-document-list">
// //           {docs.map((doc) => (
// //             <div className="bmt-document-row" key={doc}>
// //               <div><strong>{doc}</strong><span>Not uploaded</span></div>
// //               <label className="bmt-upload-small">Upload<input type="file" /></label>
// //             </div>
// //           ))}
// //         </div>
// //       </section>
// //     </div>
// //   );
// // }

// // function PropertyHighlights() {
// //   const [highlights, setHighlights] = useState(["Near major attractions", "Family friendly"]);
// //   const [value, setValue] = useState("");
// //   const add = () => {
// //     const next = value.trim();
// //     if (!next) return;
// //     setHighlights((p) => [...p, next]);
// //     setValue("");
// //   };

// //   return (
// //     <div className="bmt-premium-page">
// //       <Intro eyebrow="CONTENT QUALITY" title="Highlights & USPs" text="Add the strongest reasons a guest should choose your property." />
// //       <section className="bmt-form-card">
// //         <div className="bmt-field-group">
// //           <label>Property short description</label>
// //           <textarea rows="6" placeholder="Write a clear, premium guest-facing property description..." />
// //         </div>
// //         <div className="bmt-field-group">
// //           <label>Add highlight</label>
// //           <div className="bmt-inline-input">
// //             <input value={value} onChange={(e) => setValue(e.target.value)} placeholder="e.g. 2 minutes from the beach" />
// //             <button type="button" onClick={add}>Add</button>
// //           </div>
// //         </div>
// //         <div className="bmt-chip-wrap">
// //           {highlights.map((item, i) => (
// //             <span className="bmt-chip" key={`${item}-${i}`}>
// //               {item}
// //               <button onClick={() => setHighlights((p) => p.filter((_, x) => x !== i))}>×</button>
// //             </span>
// //           ))}
// //         </div>
// //         <FormActions saveLabel="Save Content" />
// //       </section>
// //     </div>
// //   );
// // }

// // function AnalyticsPage() {
// //   const cards = [["Revenue", "₹0", "+0%"], ["Room Nights", "0", "+0%"], ["Average Selling Price", "₹0", "+0%"], ["Conversion", "0%", "+0%"]];
// //   return (
// //     <div className="bmt-premium-page">
// //       <Intro eyebrow="PERFORMANCE" title="Analytics" text="Property performance overview for bookings, revenue and conversion." />
// //       <div className="bmt-analytics-cards">
// //         {cards.map(([title, value, trend]) => (
// //           <article key={title}><span>{title}</span><strong>{value}</strong><small>{trend} vs previous period</small></article>
// //         ))}
// //       </div>
// //       <section className="bmt-form-card">
// //         <div className="bmt-chart-placeholder"><strong>Performance chart</strong><span>Connect this section to your analytics API data.</span></div>
// //       </section>
// //     </div>
// //   );
// // }

// // function SimplePremiumPage({ title, description }) {
// //   return (
// //     <div className="bmt-premium-page">
// //       <Intro eyebrow="BIRDMYTRIP PARTNER" title={title} text={description} />
// //       <section className="bmt-form-card">
// //         <div className="bmt-empty-state">
// //           <div className="bmt-empty-icon">✦</div>
// //           <h3>{title}</h3>
// //           <p>Frontend section is ready. Connect this screen to the matching BirdMyTrip backend API when available.</p>
// //           <button className="bmt-primary-btn">Get Started</button>
// //         </div>
// //       </section>
// //     </div>
// //   );
// // }

// // function Field({ label, placeholder, type = "text" }) {
// //   return <div className="bmt-field-group"><label>{label}</label><input type={type} placeholder={placeholder} /></div>;
// // }

// // function SelectField({ label, options }) {
// //   return (
// //     <div className="bmt-field-group">
// //       <label>{label}</label>
// //       <select defaultValue=""><option value="" disabled>Select</option>{options.map((o) => <option key={o}>{o}</option>)}</select>
// //     </div>
// //   );
// // }



// import React, { useEffect, useMemo, useState } from "react";
// import VendorHotels from "./VendorHotels";
// import HotelDashboard from "./Hoteldashboard";
// import VendorCabs from "./VendorCabs";
// import VendorCabDrivers from "./VendorCabDrivers";
// import CabVendorDashboard from "./CabVendorDashboard";
// import HostelManager from "./hostel/HostelManager";
// import HostelRoomManager from "./hostel/Hostelroommanager";
// import BusModule from "./BusModule";
// import BusTripModule from "./BusTripModule";
// import BusSeatLayoutModule from "./BusSeatLayoutModule";
// import VendorBusBookings from "./VendorBusBookings";
// import VendorCabBookings from "./VendorCabBookings";
// import VendorHotelBookings from "./VendorHotelBookings";
// import VendorHotelRooms from "./Vendorhotelrooms";
// import VendorRoomInventory from "./Vendorroominventory";
// import VillaManager from "../pages/villa/VillaManager";
// import VillaRoomManager from "./villa/VillaRoomManager";
// import Villaroominventory from "../pages/villa/Villaroominventory";
// import Villaroompricing from "../pages/villa/Villaroompricing";
// import VillaBookings from "./villa/Villabooking";
// import VendorApartment from "./Vendorapartment";
// import VendorApartmentInventory from "../pages/Apartment/Vendorapartmentinventory";
// import VendorHomestay from "./VendorHomestay";
// import Homestayunitmanager from "./Homestayunitmanager";
// import VendorHomestayInventory from "./VendorHomestayInventory";
// import HomestayDashboard from "./Homestaydashboard";
// import VendorHomestayBookings from "./VendorHomestayBookings";
// import AddDarshan from "./darshan/AddDarshan";
// import Darshantype from "./darshan/Darshantype";
// import Darshanslot from "./darshan/Darshanslot";
// import Darshanavailability from "./darshan/Darshanavailability";
// import DarshanBookings from "./darshan/Vendordarshanbookings";
// import VendorHoliday from "./VendorHoliday";
// import VendorHolidayBookings from "./VendorHolidayBookings";
// import VendorBnb from "./Bnbmanager";
// import Palaceapp from "./Palaceapp";
// import AddPlace from "./Place/addPlace";
// import PalaceRoomCategories from "../pages/Place/PalaceRoomCategories";
// import PalaceAnalytics from "./Place/PalaceAnalytics";
// import PalaceRoomUnits from "./Place/PalaceRoomUnits";
// import PalaceInventory from "./Place/PalaceInventory";
// import PalaceRatePlans from "./Place/PalaceRatePlans";
// import PalaceBookings from "./Place/PalaceBookings";
// import VendorRatingsReviews from "../pages/VendorRatingsReviews";
// import VendorOffers from "../pages/Place/VendorOffers";
// import VendorAdvertisements from "../pages/Place/VendorAdvertisements";
// import VendorVacationHouse from "./Vacationhouseapp";
// import NightclubManagement from "./NightClub/NightclubManagement";
// import NightclubBookings from "./NightClub/Nightclubbookings";
// import Nightclubdashboard from "../pages/NightClub/Nightclubdashboard";
// import NightclubTables from "./NightClub/Nightclubtables";
// import NightclubTablePricing from "./NightClub/Nightclubtablepricing";
// import ManageEvents from "./NightClub/ManageEvents";
// import EventTickets from "./NightClub/EventTickets";
// import { BnbBooking } from "./bnbBooking/BnbBooking";
// import VendorProfile from "./VendorProfile";
// import VendorSupport from "../pages/Place/VendorSupport";
// import VendorPolicies from "../pages/Place/VendorPolicies";
// import VendorCruise from "./VendorCruise";
// import CabinManagement from "./CabinManagement";
// import CruiseItineraryManagement from "./CruiseItineraryManagement";
// import CruiseBookingsManagement from "./CruiseBookingsManagement";
// import CruiseSailingManagement from "./CruiseSailingManagement";
// import Tours from "./tours-activities/Tours";
// import TourBookings from "./tours-activities/Tourbookings";
// import TourQuery from "./tours-activities/TourQuery";
// import TourReview from "./tours-activities/TourReview";
// import TourSchedule from "./tours-activities/TourSchedule";
// import AddActivities from "./Activities/AddActivities";
// import ScheduleActivities from "./Activities/ScheduleActivities";
// import ActivitiesBookings from "./Activities/ActivitiesBookings";
// import AddResort from "./Resort/addResort";
// import ResortRooms from "./Resort/Resortrooms";
// import ResortRoomUnits from "./Resort/ResortRoomUnits";
// import ResortPricing from "./Resort/Resortpricing";
// import ResortInventory from "./Resort/Resortinventory";
// import ResortBookings from "./Resort/Resortbookings";
// import ResortReviews from "./Resort/Resortreviews";
// import CruiseDashboard from "./Cruisedashboard";
// import "./VendorCruise.css";
// import "./VendorLayout.css";

// /* ==================== ICONS & MENU HELPERS ==================== */

// const IC = {
//   dash: "▦", book: "▤", inv: "▥", prop: "⌂", bed: "▭", img: "▧", star: "☆", pin: "⌖", doc: "▢",
//   chart: "⌁", ship: "⚓", map: "◫", plus: "＋", price: "$", car: "◉", user: "☺", bus: "▣", seat: "▤",
//   tour: "✈", ev: "◆", club: "♪", pray: "◇", gear: "⚙", crown: "♛",
//   grow: "✦", pay: "◈", ad: "AD", eye: "◎", camp: "✦",
// };
// const L = (list) => list.map(([id, label, icon]) => ({ id, label, icon: IC[icon] }));
// const D = ["dashboard", "Dashboard", "dash"];

// /* ==================== PANELS (har service ka apna panel) ==================== */

// const PANELS = {
//   hotel: {
//     title: "Hotel", icon: IC.prop,
//     main: L([
//       D,
//       ["hotels_bookings", "Bookings", "book"],
//       ["hotel_room_inventory", "Rates & Inventory", "inv"],
//       ["hotels_manage", "Property Details", "prop"],
//       ["hotel_rooms", "Rooms & Units", "bed"],
//     ]),
//   },
//   homestay: {
//     title: "Homestay", icon: IC.prop,
//     main: L([
//       D,
//       ["homestays_bookings", "Bookings", "book"],
//       ["homestay_inventory", "Rates & Inventory", "inv"],
//       ["homestays_manage", "Property Details", "prop"],
//       ["homestay_units", "Units / Rooms", "bed"],
//     ]),
//   },
//   resort: {
//     title: "Resort", icon: IC.prop,
//     main: L([
//       D,
//       ["resort_manage", "My Resorts", "prop"],
//       ["resort_rooms", "Rooms & Categories", "bed"],
//       ["resort_bookings", "Bookings", "book"],
//       ["resort_units", "Room Units", "seat"],
//       ["resort_inventory", "Availability", "inv"],
//       ["resort_pricing", "Rates & Pricing", "inv"],
//       ["analytics", "Analytics", "chart"],
//     ]),
//   },
//   cruise: {
//     title: "Cruise", icon: IC.ship,
//     main: L([
//       D,
//       ["cruise_manage", "My Cruises", "ship"],
//       ["cruise_cabins", "Cabin Management", "bed"],
//       ["cruise_itineraries", "Itinerary Management", "map"],
//       ["cruise_sailings", "Sailing Management", "ship"],
     
//       ["cruise_add", "Add Cruise", "plus"],
//       ["cruise_bookings", "Bookings", "book"],
//     ]),
//   },
//   cab: {
//     title: "Cab", icon: IC.car,
//     main: L([
//       D,
//       ["cabs_manage", "Manage Cabs", "car"],
//       ["cabs_drivers", "Driver Management", "user"],
//       ["cabs_bookings", "Cab Bookings", "book"],
//     ]),
//   },
//   bus: {
//     title: "Bus", icon: IC.bus,
//     main: L([
//       D,
//       ["buses_manage", "Manage Buses", "bus"],
//       ["bus_trip_module", "Trip Management", "map"],
//       ["bus_seat_layout", "Seat Layout", "seat"],
//       ["buses_bookings", "Bus Bookings", "book"],
//     ]),
//   },
//   tours: {
//     title: "Tours", icon: IC.tour,
//     main: L([
//       D,
//       ["tours_manage", "Manage Tours", "tour"],
//       ["tours_bookings", "Tour Bookings", "book"],
//       ["tours_queries", "Tour Queries", "doc"],
//       ["tours_reviews", "Tour Reviews", "star"],
//       ["tours_schedule", "Tour Schedules", "map"],
//     ]),
//   },
//   activities: {
//     title: "Activities", icon: IC.ev,
//     main: L([
//       D,
//       ["activities_manage", "Manage Activities", "ev"],
//       ["activities_schedule", "Activity Schedules", "map"],
//       ["activities_bookings", "Activity Bookings", "book"],
//     ]),
//   },
//   events: {
//     title: "Events", icon: IC.ev,
//     main: L([
//       D,
//       ["events_manage", "Manage Events", "ev"],
//       ["events_tickets", "Event Tickets", "book"],
//       ["events_nightclub", "Night Club", "club"],
//       ["nightclub_tables", "Tables", "seat"],
//       ["nightclub_table_pricing", "Table Pricing", "price"],
//       ["nightclub_bookings", "Event Bookings", "book"],
//     ]),
//   },
//   nightclub: {
//     title: "Night Club", icon: IC.club,
//     main: L([
//       D,
//       ["nightclub_manage", "Manage Night Club", "club"],
//       ["nightclub_tables", "Tables", "seat"],
//       ["nightclub_table_pricing", "Table Pricing", "price"],
//     ]),
//   },
//   darshan: {
//     title: "Darshan", icon: IC.pray,
//     main: L([
//       D,
//       ["darshan_add", "Add Darshan", "plus"],
//       ["darshan_types", "Darshan Types", "tour"],
//       ["darshan_slots", "Darshan Slots", "seat"],
//       ["darshan_availability", "Slot Availability", "inv"],
//       ["darshan_bookings", "Bookings", "book"],
//     ]),
//   },
//   holidays: {
//     title: "Holidays", icon: IC.tour,
//     main: L([D, ["holidays_manage", "Manage Holidays", "tour"], ["holidays_bookings", "Holiday Bookings", "book"]]),
//   },
//   bnb: {
//     title: "BnB", icon: IC.prop,
//     main: L([D, ["bnb_manage", "Manage BnB", "prop"], ["bnb_bookings", "BnB Bookings", "book"]]),
//   },
//   palace: {
//     title: "Palace", icon: IC.crown,
//     main: L([
//       D,
//       ["palace_manage", "My Palaces", "crown"],
//       ["palace_room_categories", "Palace Room Categories", "bed"],
//       ["palace_room_units", "Room Units", "seat"],
//       ["palace_inventory", "Room Inventory", "inv"],
//       ["palace_rate_plans", "Rate Plans & Pricing", "price"],
//       ["palace_bookings", "Palace Bookings", "book"],
//       ["palace_analytics", "Analytics", "chart"],
//     ]),
//   },
//   vacation: {
//     title: "Vacation House", icon: IC.prop,
//     main: L([D, ["vacationhouses_manage", "Manage Houses", "prop"], ["vacationhouses_bookings", "Bookings", "book"]]),
//   },
//   villa: {
//     title: "Villa", icon: IC.prop,
//     main: L([
//       D,
//       ["villa_manage", "Manage Villas", "prop"],
//       ["villa_rooms", "Villa Rooms", "bed"],
//       ["villa_inventory", "Room Inventory", "inv"],
//       ["villa_pricing", "Room Pricing", "inv"],
//       ["villa_bookings", "Villa Bookings", "book"],
//     ]),
//   },
//   apartments: {
//     title: "Apartments", icon: IC.prop,
//     main: L([
//       D,
//       ["apartments_manage", "Manage Apartments", "prop"],
//       ["apartments_inventory", "Apartment Inventory", "inv"],
//     ]),
//   },
//   partner: { title: "Partner", icon: IC.dash, main: L([D]) },
// };

// Object.keys(PANELS).forEach((k) => {
//   PANELS[k] = { ...PANELS[k], base: k };
// });

// /* ==================== NAYE STAY SUBTYPES ====================
//    Har subtype ka apna dashboard, apna menu, apne tab ids (motel_*, hostel_* ...).
//    Hotel / homestay ke components yahan KABHI nahi khulte.
//    Jis page ka component bana nahi, wahan khali naya page khulta hai.

//    Naya menu item add karna ho -> us subtype ke `extra` mein add karo.
// ============================================================ */

// const STAY_SUBTYPES = {
//   hostel: {
//     title: "Hostel", icon: IC.bed, unit: "Bed Nights", occupancy: "Beds occupied tonight",
//     banner: "Track bed nights, dorm and private room occupancy, revenue per bed and check-ins.",
//     setup: ["Add or Edit Hostel Details", "Add Dorms & Private Rooms", "Set Bed Rates & Availability", "Review House Rules & Check-in Times"],
//     snapshot: ["Pending", "Confirmed", "Beds Available", "Checked-out"],
//     extra: [],
//   },
//   motel: {
//     title: "Motel", icon: IC.prop, unit: "Room Nights", occupancy: "Rooms occupied tonight",
//     banner: "Track room nights, drive-in bookings, revenue and check-ins for your motel.",
//     setup: ["Add or Edit Motel Details", "Add Rooms & Parking Info", "Set Room Rates & Availability", "Review Policies & Check-in Times"],
//     snapshot: ["Pending", "Confirmed", "Rooms Available", "Checked-out"],
//     extra: [],
//   },
//   lodge: {
//     title: "Lodge", icon: IC.prop, unit: "Room Nights", occupancy: "Rooms occupied tonight",
//     banner: "Track room nights, revenue and check-ins for your lodge.",
//     setup: ["Add or Edit Lodge Details", "Add Rooms & Cottages", "Set Rates & Availability", "Review Policies & Check-in Times"],
//     snapshot: ["Pending", "Confirmed", "Rooms Available", "Checked-out"],
//     extra: [],
//   },
//   inn: {
//     title: "Inn", icon: IC.prop, unit: "Room Nights", occupancy: "Rooms occupied tonight",
//     banner: "Track room nights, revenue and check-ins for your inn.",
//     setup: ["Add or Edit Inn Details", "Add Rooms", "Set Rates & Availability", "Review Policies & Check-in Times"],
//     snapshot: ["Pending", "Confirmed", "Rooms Available", "Checked-out"],
//     extra: [],
//   },
//   guesthouse: {
//     title: "Guest House", icon: IC.prop, unit: "Room Nights", occupancy: "Rooms occupied tonight",
//     banner: "Track guest bookings, room nights, revenue and check-ins for your guest house.",
//     setup: ["Add or Edit Guest House Details", "Add Rooms", "Set Rates & Availability", "Review House Rules & Check-in Times"],
//     snapshot: ["Pending", "Confirmed", "Rooms Available", "Checked-out"],
//     extra: [],
//   },
//   farmstay: {
//     title: "Farm Stay", icon: IC.prop, unit: "Stay Nights", occupancy: "Units occupied tonight",
//     banner: "Track stay nights, revenue and check-ins for your farm stay.",
//     setup: ["Add or Edit Farm Stay Details", "Add Rooms / Cottages", "Set Rates & Availability", "Review Rules & Check-in Times"],
//     snapshot: ["Pending", "Confirmed", "Units Available", "Checked-out"],
//     extra: [],
//   },
//   campsite: {
//     title: "Campsite", icon: IC.camp, unit: "Camp Nights", occupancy: "Tents / pitches occupied tonight",
//     banner: "Track camp nights, tent occupancy, revenue and check-ins for your campsite.",
//     setup: ["Add or Edit Campsite Details", "Add Tents & Pitches", "Set Rates & Availability", "Review Safety Rules & Check-in Times"],
//     snapshot: ["Pending", "Confirmed", "Tents Available", "Checked-out"],
//     extra: [],
//   },
//   camp: {
//     title: "Camp", icon: IC.camp, unit: "Camp Nights", occupancy: "Tents occupied tonight",
//     banner: "Track camp nights, tent occupancy, revenue and check-ins for your camp.",
//     setup: ["Add or Edit Camp Details", "Add Tents", "Set Rates & Availability", "Review Safety Rules & Check-in Times"],
//     snapshot: ["Pending", "Confirmed", "Tents Available", "Checked-out"],
//     extra: [],
//   },
//   "serviced-apartment": {
//     title: "Serviced Apartment", icon: IC.prop, unit: "Apartment Nights", occupancy: "Apartments occupied tonight",
//     banner: "Track apartment nights, long-stay bookings, revenue and check-ins.",
//     setup: ["Add or Edit Apartment Details", "Add Apartment Units", "Set Rates & Availability", "Review Policies & Check-in Times"],
//     snapshot: ["Pending", "Confirmed", "Apartments Available", "Checked-out"],
//     extra: [],
//   },
// };

// /*
//   REAL PAGES ADD KARNE KI JAGAH
//   Jab kisi subtype ka component bana lo, import karke yahan daal do.
//   Tab id ka format: `${subtypeKey}_bookings | _inventory | _manage | _rooms`
//   Example:
//     import MotelBookings from "./motel/MotelBookings";
//     const CUSTOM_PAGES = { motel_bookings: <MotelBookings />, };
//   Jo yahan nahi hoga, wahan khali "naya page" dikhega.
// */
// const CUSTOM_PAGES = {
//   hostel_manage: <HostelManager />,
//   hostel_rooms: <HostelRoomManager />,
//   // motel_bookings: <MotelBookings />,
//   // motel_rooms: <MotelRooms />,
//   // hostel_bookings: <HostelBookings />,
// };

// const SUBTYPE_PANELS = {};
// Object.entries(STAY_SUBTYPES).forEach(([k, s]) => {
//   const menu = [
//     D,
//     [`${k}_bookings`, "Bookings", "book"],
//     [`${k}_inventory`, "Rates & Inventory", "inv"],
//     [`${k}_manage`, `${s.title} Details`, "prop"],
//     [`${k}_rooms`, "Rooms & Units", "bed"],
//     ...s.extra,
//   ];
//   PANELS[k] = { title: s.title, icon: s.icon, base: k, main: L(menu) };
//   SUBTYPE_PANELS[k] = true;
// });

// /* ==================== ACCOUNT / COMMON MENU ==================== */

// const ACCOUNT = L([
//   ["profile_personal", "My Profile", "user"],
//   ["profile_business", "Business Details", "prop"],
//   ["profile_contact", "Contact Details", "pin"],
//   ["profile_tax", "Tax & Identity", "doc"],
//   ["profile_bank", "Bank Details", "pay"],
//   ["profile_service", "Service Details", "gear"],
//   ["settings", "Settings", "gear"],
// ]);

// const COMMON_VENDOR_MENU = L([
//   ["vendor_offers", "Offers & Promotions", "grow"],
//   ["vendor_advertisements", "Advertisements", "ad"],
//   ["vendor_support", "Support", "doc"],
//   ["vendor_ratings_reviews", "Ratings & Reviews", "star"],
//   ["vendor_policies", "Privacy & Policies", "gear"],
// ]);

// /* ==================== ALIASES: har service apne hi key par ==================== */

// const normalizeService = (value) =>
//   String(value || "")
//     .trim()
//     .toLowerCase()
//     .replace(/[_\s]+/g, "-")
//     .replace(/-+/g, "-");

// const ALIASES = {
//   hotel: "hotel", hotels: "hotel",
//   motel: "motel", motels: "motel",
//   lodge: "lodge", lodges: "lodge",
//   inn: "inn", inns: "inn",
//   homestay: "homestay", homestays: "homestay", "home-stay": "homestay",
//   hostel: "hostel", hostels: "hostel",
//   guesthouse: "guesthouse", guesthouses: "guesthouse", "guest-house": "guesthouse",
//   farmstay: "farmstay", farmstays: "farmstay", "farm-stay": "farmstay",
//   farmhouse: "farmstay", "farm-house": "farmstay",
//   campsite: "campsite", campsites: "campsite", "camp-site": "campsite",
//   camp: "camp", camps: "camp",
//   resort: "resort", resorts: "resort",
//   palace: "palace", palaces: "palace",
//   bnb: "bnb", "bed-and-breakfast": "bnb", "bed-breakfast": "bnb", "b-and-b": "bnb", stay: "bnb",
//   apartment: "apartments", apartments: "apartments",
//   "serviced-apartment": "serviced-apartment", "serviced-apartments": "serviced-apartment",
//   "vacation-house": "vacation", "vacation-home": "vacation", "vacation-homes": "vacation",
//   vacation: "vacation", vacationhouse: "vacation",
//   villa: "villa", villas: "villa",

//   cab: "cab", cabs: "cab", "car-rental": "cab",
//   bus: "bus", buses: "bus",
//   cruise: "cruise", cruises: "cruise",
//   package: "tours", packages: "tours", tours: "tours", tour: "tours",
//   activity: "activities", activities: "activities",
//   events: "events", event: "events",
//   darshan: "darshan", darshans: "darshan", "bmt-darshan": "darshan",
//   holiday: "holidays", holidays: "holidays",
//   nightclub: "nightclub", nightclubs: "nightclub", "night-club": "nightclub",
// };

// /* ==================== SIMPLE (placeholder) PAGES ==================== */

// const SIMPLE_PAGES = {
//   promotions: ["Promotions & Offers", "Create property discounts, mobile offers, early-bird offers and limited-time deals."],
//   visibility_boost: ["Visibility Booster", "Improve property visibility with sponsored placement and performance campaigns."],
//   campaigns: ["Campaigns", "Manage seasonal campaigns and marketing participation."],
//   payments: ["Payments", "View settlements, payment status, deductions and payout history."],
//   sponsored: ["Sponsored Listing", "Boost your property ranking through paid sponsored placement."],
//   ratings_reviews: ["Ratings & Reviews", "Track guest ratings, review reasons and respond to guest feedback."],
//   events_bookings: ["Event Bookings", "View and manage bookings received for your events."],
//   vacationhouses_bookings: ["Vacation House Bookings", "Manage upcoming, completed and cancelled reservations."],
//   cruise_pricing: ["Pricing Management", "Set cabin prices and seasonal rates for your sailings."],
//   // cruise_bookings: ["Cruise Bookings", "View and manage bookings received for your sailings."],
//   settings: ["Settings", "Manage your account preferences."],
// };

// const PROFILE_SECTIONS = {
//   profile_personal: "personal",
//   profile_business: "business",
//   profile_contact: "contact",
//   profile_tax: "tax",
//   profile_bank: "bank",
//   profile_service: "service",
// };

// /* ==================== TAB -> PAGE MAP ==================== */

// const PAGES = {
//   vendor_offers: <VendorOffers />,
//   vendor_advertisements: <VendorAdvertisements />,
//   vendor_support: <VendorSupport />,
//   vendor_policies: <VendorPolicies />,
//   vendor_ratings_reviews: <VendorRatingsReviews />,
//   // Hotel
//   hotels_manage: <VendorHotels />,
//   hotel_rooms: <VendorHotelRooms />,
//   hotel_room_inventory: <VendorRoomInventory />,
//   hotels_bookings: <VendorHotelBookings />,
//   // Homestay
//   homestays_manage: <VendorHomestay />,
//   homestay_units: <Homestayunitmanager />,
//   homestay_inventory: <VendorHomestayInventory />,
//   homestays_bookings: <VendorHomestayBookings />,
//   // Resort
//   resort_manage: <AddResort />,
//   resort_rooms: <ResortRooms />,
//   resort_units: <ResortRoomUnits />,
//   resort_pricing: <ResortPricing />,
//   resort_bookings: <ResortBookings />,
//   resort_reviews: <ResortReviews />,
//   resort_inventory: <ResortInventory />,
//   // Shared property info
//   property_media: <PropertyMedia />,
//   property_amenities: <PropertyAmenities />,
//   property_location: <PropertyLocation />,
//   property_policies: <PropertyPolicies />,
//   property_documents: <PropertyDocuments />,
//   property_highlights: <PropertyHighlights />,
//   analytics: <AnalyticsPage />,
//   // BnB / Apartments
//   bnb_manage: <VendorBnb />,
//   bnb_bookings: <BnbBooking />,
//   apartments_manage: <VendorApartment />,
//   apartments_inventory: <VendorApartmentInventory />,
//   // Cab
//   cabs_manage: <VendorCabs />,
//   cabs_drivers: <VendorCabDrivers />,
//   cabs_bookings: <VendorCabBookings />,
//   // Bus
//   buses_manage: <BusModule />,
//   bus_trip_module: <BusTripModule />,
//   bus_seat_layout: <BusSeatLayoutModule />,
//   buses_bookings: <VendorBusBookings />,
//   // Cruise
//   cruise_manage: <VendorCruise />,
//   cruise_add: <VendorCruise />,
//   cruise_cabins: <CabinManagement />,
//   cruise_itineraries: <CruiseItineraryManagement />,
//   cruise_bookings: <CruiseBookingsManagement />,
//   cruise_sailings: <CruiseSailingManagement />,
//   // Tours
//   tours_manage: <Tours />,
//   tours_bookings: <TourBookings />,
//   tours_queries: <TourQuery />,
//   tours_reviews: <TourReview />,
//   tours_schedule: <TourSchedule />,
//   // Activities
//   activities_manage: <AddActivities />,
//   activities_schedule: <ScheduleActivities />,
//   activities_bookings: <ActivitiesBookings />,
//   // Events / Night club
//   events_manage: <ManageEvents />,
//   events_tickets: <EventTickets />,
//   nightclub_manage: <NightclubManagement />,
//   events_nightclub: <NightclubManagement />,
//   // Nightclub
// nightclub_dashboard: <Nightclubdashboard />,
//   nightclub_tables: <NightclubTables />,
//   nightclub_bookings: <NightclubBookings />,
//   nightclub_table_pricing: <NightclubTablePricing />,
//   // Darshan
//   darshan_add: <AddDarshan />,
//   darshan_types: <Darshantype />,
//   darshan_slots: <Darshanslot />,
//   darshan_availability: <Darshanavailability />,
//   darshan_bookings: <DarshanBookings />,
//   // Villa
//   villa_manage: <VillaManager />,
//   villa_rooms: <VillaRoomManager />,
//   villa_inventory: <Villaroominventory />,
//   villa_pricing: <Villaroompricing />,
//   villa_bookings: <VillaBookings />,
//   // Palace
//   palace_manage: <AddPlace />,
//   palace_rooms: <Palaceapp />,
//   palace_room_categories: <PalaceRoomCategories />,
//   palace_room_units: <PalaceRoomUnits />,
//   palace_inventory: <PalaceInventory />,
//   palace_rate_plans: <PalaceRatePlans />,
//   palace_bookings: <PalaceBookings />,
//   palace_analytics: <PalaceAnalytics />,
//   // Others
//   vacationhouses_manage: <VendorVacationHouse />,
//   holidays_manage: <VendorHoliday />,
//   holidays_bookings: <VendorHolidayBookings />,
// };

// /* ==================== DASHBOARD SHORTCUTS ==================== */

// const STAY_PANELS = ["hotel", "homestay", "resort", "bnb", "palace", "vacation", "villa", "apartments"];

// const BOOKING_TARGET = {
//   hotel: "hotels_bookings", homestay: "homestays_bookings", resort: "resort_bookings",
//   bnb: "bnb_bookings", vacation: "vacationhouses_bookings", villa: "villa_bookings",
//   palace: "palace_bookings", apartments: "apartments_manage", bus: "buses_bookings",
//   cab: "cabs_bookings", activities: "activities_bookings", darshan: "darshan_bookings",
//   tours: "tours_bookings", holidays: "holidays_bookings", cruise: "cruise_bookings",
//   events: "events_tickets", nightclub: "nightclub_manage",
// };

// const INVENTORY_TARGET = {
//   hotel: "hotel_room_inventory", homestay: "homestay_inventory", resort: "resort_inventory",
//   palace: "palace_inventory", villa: "villa_inventory", apartments: "apartments_inventory",
//   activities: "activities_schedule", darshan: "darshan_availability",
//   nightclub: "nightclub_table_pricing", tours: "tours_schedule", bus: "bus_trip_module",
//   cab: "cabs_manage", cruise: "cruise_sailings",
// };

// const SETUP_ACTIONS = {
//   resort: [
//     ["resort_manage", "Add or Edit Resorts"],
//     ["resort_rooms", "Add Room Categories & Prices"],
//     ["resort_manage", "Review Policies & Check-in Times"],
//     ["resort_units", "Add Room Numbers (Units)"],
//     ["resort_pricing", "Set Rate Plans & Date Prices"],
//   ],
//   palace: [
//     ["palace_manage", "Add or Edit Palaces"],
//     ["palace_manage", "Upload Gallery & Set Cover Image"],
//     ["palace_manage", "Review Policies & Check-in Times"],
//     ["palace_rooms", "Add Rooms, Rates & Inventory"],
//   ],
//   default: [
//     ["property_media", "Add Images & Videos"],
//     ["property_amenities", "Update Amenities & Facilities"],
//     ["property_policies", "Review Property Policies"],
//   ],
// };

// /* ==================== HELPERS ==================== */

// const pathTab = () => {
//   const p = typeof window !== "undefined" ? window.location.pathname : "";
//   if (p.includes("/vendor/cab/driver") || p.includes("/vendor/cab-driver")) return "cabs_drivers";
//   if (p.includes("/vendor/cab/booking")) return "cabs_bookings";
//   if (p.includes("/vendor/cab/manage")) return "cabs_manage";
//   if (p.includes("/vendor/darshan/add")) return "darshan_add";
//   if (p.includes("/vendor/darshan/types")) return "darshan_types";
//   if (p.includes("/vendor/darshan/slots")) return "darshan_slots";
//   if (p.includes("/vendor/darshan/availability")) return "darshan_availability";
//   if (p.includes("/vendor/darshan/bookings")) return "darshan_bookings";
//   if (p.includes("/vendor/nightclub/pricing")) return "nightclub_table_pricing";
//   if (p.includes("/vendor/nightclub/tables")) return "nightclub_tables";
//   return "";
// };

// const urlStaySubtype = () => {
//   if (typeof window === "undefined") return "";
//   const m = window.location.pathname.match(/\/vendor\/stay\/([^/]+)/);
//   return m ? normalizeService(decodeURIComponent(m[1])) : "";
// };

// const clearSession = () => {
//   localStorage.removeItem("vendorToken");
//   localStorage.removeItem("vendorUser");
//   sessionStorage.removeItem("bmtVendorActiveTab");
// };

// function resolveVendorService(vendor) {
//   const vertical = normalizeService(vendor.vertical || vendor.selectedVertical || "");
//   const fromUrl = urlStaySubtype();

//   let resolved;
//   if (vertical && vertical !== "stay") {
//     resolved = vertical;
//   } else {
//     const subtype = normalizeService(
//       vendor.staySubtype ||
//         vendor.business?.staySubtype ||
//         vendor.business?.propertyType ||
//         vendor.propertyType ||
//         vendor.business?.service ||
//         vendor.service ||
//         ""
//     );
//     resolved = fromUrl || subtype || "stay";
//   }

//   console.log("VENDOR RESOLVE:", {
//     vertical: vendor.vertical,
//     selectedVertical: vendor.selectedVertical,
//     staySubtype: vendor.staySubtype,
//     service: vendor.service,
//     propertyType: vendor.propertyType,
//     urlSubtype: fromUrl,
//     resolved,
//     panelKey: ALIASES[resolved] || "partner",
//   });

//   return resolved;
// }

// /* ==================== ERROR BOUNDARY ==================== */

// class PageErrorBoundary extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = { error: null };
//   }
//   static getDerivedStateFromError(error) {
//     return { error };
//   }
//   componentDidCatch(error, info) {
//     console.error("VENDOR PAGE CRASH:", error, info);
//   }
//   componentDidUpdate(prevProps) {
//     if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
//       this.setState({ error: null });
//     }
//   }
//   render() {
//     if (this.state.error) {
//       return (
//         <div style={{ padding: 24 }}>
//           <h3 style={{ color: "#b91c1c" }}>Is page mein error aaya</h3>
//           <pre style={{ whiteSpace: "pre-wrap", fontSize: 13 }}>
//             {String(this.state.error?.message || this.state.error)}
//           </pre>
//         </div>
//       );
//     }
//     return this.props.children;
//   }
// }

// /* ==================== MAIN LAYOUT ==================== */

// export default function VendorLayout() {
//   const [activeTab, setActiveTab] = useState(
//     () => pathTab() || sessionStorage.getItem("bmtVendorActiveTab") || "dashboard"
//   );
//   const [accountOpen, setAccountOpen] = useState(() =>
//     String(pathTab() || sessionStorage.getItem("bmtVendorActiveTab") || "dashboard").startsWith("profile_")
//   );
//   const [vendorName, setVendorName] = useState("");
//   const [vendorService, setVendorService] = useState("");
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     const token = localStorage.getItem("vendorToken");
//     const stored = localStorage.getItem("vendorUser");
//     if (!token || !stored) {
//       clearSession();
//       window.location.href = "/vendor-login";
//       return;
//     }
//     try {
//       const vendor = JSON.parse(stored);
//       setVendorName(
//         vendor.business?.businessName ||
//           vendor.businessName ||
//           vendor.companyName ||
//           vendor.name ||
//           vendor.ownerName ||
//           vendor.email ||
//           "Vendor"
//       );

//       const resolvedService = resolveVendorService(vendor);
//       setVendorService(resolvedService);

//       if (resolvedService === "cruise" && String(activeTab).startsWith("profile_")) {
//         setActiveTab("cruise_manage");
//         sessionStorage.setItem("bmtVendorActiveTab", "cruise_manage");
//       }
//     } catch (error) {
//       console.error("VENDOR SESSION ERROR:", error);
//       clearSession();
//       window.location.href = "/vendor-login";
//       return;
//     } finally {
//       setLoading(false);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   const key = ALIASES[normalizeService(vendorService)] || "partner";
//   const panel = PANELS[key] || PANELS.partner;
//   const baseKey = panel.base || key;

//   const allIds = useMemo(
//     () =>
//       new Set(
//         [...panel.main, ...ACCOUNT, ...COMMON_VENDOR_MENU]
//           .map((item) => item.id)
//           .concat(Object.keys(PROFILE_SECTIONS))
//       ),
//     [panel]
//   );
//   const tab = allIds.has(activeTab) ? activeTab : "dashboard";

//   useEffect(() => {
//     sessionStorage.setItem("bmtVendorActiveTab", tab);
//   }, [tab]);

//   const logout = () => {
//     if (window.confirm("Are you sure you want to logout?")) {
//       clearSession();
//       window.location.href = "/vendor-login";
//     }
//   };

//   // const renderContent = () => {
//   //   // A. Naye stay subtypes (hostel, motel, lodge ...): sirf apne dashboard aur apne pages
//   //   if (SUBTYPE_PANELS[key] && (tab === "dashboard" || tab.startsWith(`${key}_`))) {
//   //     if (tab === "dashboard") {
//   //       return <StayDashboard serviceKey={key} onNavigate={setActiveTab} />;
//   //     }
//   //     return (
//   //       CUSTOM_PAGES[tab] || (
//   //         <NewSubtypePage
//   //           serviceKey={key}
//   //           tabId={tab}
//   //           label={panel.main.find((m) => m.id === tab)?.label || "New Page"}
//   //         />
//   //       )
//   //     );
//   //   }

//   //   // B. Baaki services ke dashboards
//   //   if (tab === "dashboard") {
//   //     switch (key) {
//   //       case "cab":
//   //         return <CabVendorDashboard onNavigate={setActiveTab} />;
//   //       case "hotel":
//   //         return <HotelDashboard onNavigate={setActiveTab} />;
//   //       case "homestay":
//   //         return <HomestayDashboard onNavigate={setActiveTab} />;
//   //       default:
//   //         return (
//   //           <DashboardContent panelKey={baseKey} panelTitle={panel.title} onNavigate={setActiveTab} />
//   //         );
//   //     }
//   //   }

//   //   if (PROFILE_SECTIONS[tab]) {
//   //     return <VendorProfile initialSection={PROFILE_SECTIONS[tab]} />;
//   //   }

//   //   if (SIMPLE_PAGES[tab]) {
//   //     const [title, description] = SIMPLE_PAGES[tab];
//   //     return <SimplePremiumPage title={title} description={description} />;
//   //   }

//   //   return (
//   //     PAGES[tab] || (
//   //       <DashboardContent panelKey={baseKey} panelTitle={panel.title} onNavigate={setActiveTab} />
//   //     )
//   //   );
//   // };
//   const renderContent = () => {
//   // 1. Dashboard: har vendor type ka apna dashboard
//   if (tab === "dashboard") {
//     switch (key) {
//       case "cab":
//         return <CabVendorDashboard onNavigate={setActiveTab} />;
//       case "homestay":
//         return <HomestayDashboard onNavigate={setActiveTab} />;
//         case "hotel":                                              
//       return <HotelDashboard onNavigate={setActiveTab} />;
//        case "cruise":
//         return <CruiseDashboard onNavigate={setActiveTab} />;
//        case "events":
//   return <Nightclubdashboard onNavigate={setActiveTab} />;

// case "nightclub":
//   return <Nightclubdashboard onNavigate={setActiveTab} />;
//       default:
//         return <DashboardContent panelKey={key} onNavigate={setActiveTab} />;
//     }
//   }

//   // 2. Profile ke sub-sections (personal, business, bank...)
//   if (PROFILE_SECTIONS[tab]) {
//     return <VendorProfile initialSection={PROFILE_SECTIONS[tab]} />;
//   }

//   // 3. Placeholder pages (jinka backend abhi connected nahi hai)
//   if (SIMPLE_PAGES[tab]) {
//     const [title, description] = SIMPLE_PAGES[tab];
//     return <SimplePremiumPage title={title} description={description} />;
//   }

//   // 4. Real pages, warna dashboard par wapas
//   return PAGES[tab] || <DashboardContent panelKey={key} onNavigate={setActiveTab} />;
// };

//   if (loading) {
//     return (
//       <div className="bmt-loader">
//         <div className="bmt-loader-ring" />
//         <p>Loading BirdMyTrip Partner Panel...</p>
//       </div>
//     );
//   }

//   const NavButton = ({ item }) => (
//     <button
//       className={`vx-item ${tab === item.id ? "active" : ""}`}
//       onClick={() => setActiveTab(item.id)}
//       title={item.label}
//     >
//       <span className="vx-icon">{item.icon}</span>
//       <span className="vx-label">{item.label}</span>
//     </button>
//   );

//   return (
//     <div className="vx-app">
//       <div className="vx-side">
//         <div className="vx-brand-box">
//           <div className="vx-brandmark">{panel.icon}</div>
//           <div className="vx-brand-title"><strong>{panel.title}</strong><span>Vendor</span></div>
//         </div>

//         <div className="vx-nav">
//           <div className="vx-section">Main menu</div>
//           {panel.main.map((item) => <NavButton key={item.id} item={item} />)}

//           <div className="vx-section">Help & Legal</div>
//           {COMMON_VENDOR_MENU.map((item) => (
//             <NavButton key={item.id} item={item} />
//           ))}

//           <div className="vx-section">Account</div>

//           <button
//             type="button"
//             className={`vx-item vx-account-toggle ${
//               String(activeTab).startsWith("profile_") ? "active" : ""
//             }`}
//             onClick={() => setAccountOpen((prev) => !prev)}
//             aria-expanded={accountOpen}
//           >
//             <span className="vx-icon">{IC.user}</span>
//             <span className="vx-label">My Profile</span>
//             <span className={`vx-account-arrow ${accountOpen ? "expanded" : ""}`}>›</span>
//           </button>

//           {accountOpen && (
//             <div className="vx-account-submenu">
//               {ACCOUNT.filter(
//                 (item) => item.id.startsWith("profile_") && item.id !== "profile_personal"
//               ).map((item) => (
//                 <NavButton key={item.id} item={item} />
//               ))}
//             </div>
//           )}
//         </div>

//         <div className="vx-side-foot">
//           <div className="vx-portal">
//             <span className="vx-portal-icon">▮</span>
//             <div><b>Vendor Portal</b><small>Manage your {panel.title.toLowerCase()} business</small></div>
//           </div>
//           <button className="vx-logout" onClick={logout}>
//             <span className="vx-icon">↪</span><span className="vx-label">Logout</span>
//           </button>
//         </div>
//       </div>

//       <div className="vx-main-wrap">
//         <div className="vx-top">
//           <div className="vx-brand">
//             <div className="vx-logo">bmt</div>
//             <div className="vx-brand-text">
//               <strong className="vx-name">{vendorName || "BirdMyTrip Partner"}</strong>
//               <div className="vx-sub-line"><span className="vx-pill">{panel.title}</span><span>BirdMyTrip Verified Partner</span></div>
//             </div>
//           </div>
//           <div className="vx-top-actions">
//             <button className="vx-help" aria-label="Help">?</button>
//             <button className="vx-user" onClick={() => setActiveTab("profile_personal")}>
//               <span className="vx-avatar">{(vendorName || "V").charAt(0).toUpperCase()}</span>
//               <span className="vx-user-text"><b>{vendorName || "Vendor"}</b><small>Partner</small></span>
//             </button>
//           </div>
//         </div>

//         <div className="vx-main">
//           <div className="vx-content">
//             <PageErrorBoundary resetKey={`${key}-${tab}`}>
//               {renderContent()}
//             </PageErrorBoundary>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// /* ==================== STAY SUBTYPE DASHBOARD (hostel, motel, lodge, ...) ==================== */

// function StayDashboard({ serviceKey, onNavigate }) {
//   const cfg = STAY_SUBTYPES[serviceKey];

//   const name = useMemo(() => {
//     try {
//       const v = JSON.parse(localStorage.getItem("vendorUser") || "{}");
//       return (
//         v?.business?.businessName ||
//         v?.businessName ||
//         v?.companyName ||
//         v?.name ||
//         `Your ${cfg?.title || "Property"}`
//       );
//     } catch {
//       return `Your ${cfg?.title || "Property"}`;
//     }
//   }, [cfg]);

//   if (!cfg) return null;

//   const t = {
//     bookings: `${serviceKey}_bookings`,
//     inventory: `${serviceKey}_inventory`,
//     manage: `${serviceKey}_manage`,
//     rooms: `${serviceKey}_rooms`,
//   };

//   const metrics = [
//     { title: `Today's ${cfg.unit}`, value: "0", sub: `FOR LAST 7 DAYS : 0 ${cfg.unit.toUpperCase()}`, action: t.bookings },
//     { title: "Today's Revenue", value: "₹ 0", sub: "FOR LAST 7 DAYS : ₹ 0", action: t.bookings },
//     { title: "Occupancy Rate", value: "0%", sub: cfg.occupancy.toUpperCase(), action: t.inventory },
//     { title: "Today's Check-ins", value: "0", sub: "FOR LAST 7 DAYS : 0 CHECK-INS", action: t.bookings },
//   ];
//   const setupTargets = [t.manage, t.rooms, t.inventory, t.manage];

//   return (
//     <div className="bmt-dashboard">
//       <section className="bmt-performance-head">
//         <div className="bmt-title-line">
//           <h1>{cfg.title} Dashboard</h1>
//           <span className="bmt-info-icon">?</span>
//         </div>
//         <p>{name} · Last updated just now</p>
//       </section>

//       <section className="bmt-analytics-banner">
//         <div>
//           <h2>{cfg.title} Analytics</h2>
//           <p>{cfg.banner}</p>
//         </div>
//         <button onClick={() => onNavigate(t.manage)}>View All</button>
//       </section>

//       <section className="bmt-metrics-grid">
//         {metrics.map((m) => (
//           <article className="bmt-metric-card" key={m.title}>
//             <h3>{m.title}</h3>
//             <div className="bmt-metric-value">{m.value}</div>
//             <p>{m.sub}</p>
//             <button onClick={() => onNavigate(m.action)}>View More</button>
//           </article>
//         ))}
//       </section>

//       <section className="bmt-dashboard-bottom-grid">
//         <article className="bmt-panel-card">
//           <div className="bmt-card-header">
//             <div><h3>{cfg.title} Setup</h3><p>Complete your {cfg.title.toLowerCase()} listing</p></div>
//             <span className="bmt-new-badge">NEW</span>
//           </div>
//           <div className="bmt-action-list">
//             {cfg.setup.map((label, i) => (
//               <button key={label} onClick={() => onNavigate(setupTargets[i] || t.manage)}>
//                 <span>{label}</span><b>›</b>
//               </button>
//             ))}
//           </div>
//         </article>

//         <article className="bmt-panel-card">
//           <div className="bmt-card-header">
//             <div><h3>Today's Snapshot</h3><p>Quick operational summary</p></div>
//           </div>
//           <div className="bmt-snapshot-grid">
//             {cfg.snapshot.map((s) => (
//               <div key={s}><strong>0</strong><span>{s}</span></div>
//             ))}
//           </div>
//         </article>
//       </section>
//     </div>
//   );
// }

// /* Khali naya page: jab tak asli component CUSTOM_PAGES mein add nahi hota */
// function NewSubtypePage({ serviceKey, tabId, label }) {
//   const cfg = STAY_SUBTYPES[serviceKey];
//   return (
//     <div className="bmt-premium-page">
//       <Intro
//         eyebrow={`${(cfg?.title || "").toUpperCase()} PARTNER`}
//         title={label}
//         text={`${cfg?.title || "Is service"} ka ${label} page abhi bana nahi hai.`}
//       />
//       <section className="bmt-form-card">
//         <div className="bmt-empty-state">
//           <div className="bmt-empty-icon">✦</div>
//           <h3>{cfg?.title} · {label}</h3>
//           <p>
//             Is page ka component banao aur <code>CUSTOM_PAGES</code> mein <code>{tabId}</code> naam se add kar do.
//           </p>
//         </div>
//       </section>
//     </div>
//   );
// }

// /* ==================== DASHBOARD (generic) ==================== */

// function DashboardContent({ panelKey, panelTitle, onNavigate }) {
//   const isStay = STAY_PANELS.includes(panelKey);
//   const bookingTarget = BOOKING_TARGET[panelKey] || "dashboard";
//   const inventoryTarget = INVENTORY_TARGET[panelKey] || "dashboard";
//   const setupActions = SETUP_ACTIONS[panelKey] || SETUP_ACTIONS.default;
//   const title = panelTitle || "";

//   const metrics = isStay ? [
//     { title: "Today's Room Nights", value: "0", sub: "FOR LAST 7 DAYS : 3 ROOM NIGHTS", action: bookingTarget },
//     { title: "Today's Revenue", value: "₹ 0", sub: "FOR LAST 7 DAYS : ₹ 3,239", action: bookingTarget },
//     { title: "Today's Average Selling Price", value: "₹ 0", sub: "FOR LAST 7 DAYS : ₹ 1,371", action: inventoryTarget },
//     { title: "Today's Check-ins", value: "0", sub: "FOR LAST 7 DAYS : 3 CHECK-INS", action: bookingTarget },
//   ] : [
//     { title: "Today's Bookings", value: "0", sub: "FOR LAST 7 DAYS : 12 BOOKINGS", action: bookingTarget },
//     { title: "Today's Revenue", value: "₹ 0", sub: "FOR LAST 7 DAYS : ₹ 8,920", action: bookingTarget },
//     { title: "Active Listings", value: "8", sub: "CURRENTLY LIVE ON BIRDMYTRIP", action: inventoryTarget },
//     { title: "Upcoming Operations", value: "5", sub: "NEXT 7 DAYS", action: bookingTarget },
//   ];

//   return (
//     <div className="bmt-dashboard">
//       <section className="bmt-performance-head">
//         <div className="bmt-title-line">
//           <h1>{title ? `${title} Performance Overview` : "Performance Overview"}</h1>
//           <span className="bmt-info-icon">?</span>
//         </div>
//         <p>Last updated just now</p>
//       </section>

//       <section className="bmt-analytics-banner">
//         <div>
//           <h2>{isStay ? `${title || "Property"} Analytics` : "Business Analytics"}</h2>
//           <p>See detailed analysis and past data for Revenue, Room Nights, Average Selling Price, Conversion, Bookings and more.</p>
//         </div>
//         <button onClick={() => onNavigate("analytics")}>View All</button>
//       </section>

//       <section className="bmt-metrics-grid">
//         {metrics.map((m) => (
//           <article className="bmt-metric-card" key={m.title}>
//             <h3>{m.title}</h3>
//             <div className="bmt-metric-value">{m.value}</div>
//             <p>{m.sub}</p>
//             <button onClick={() => onNavigate(m.action)}>View More</button>
//           </article>
//         ))}
//       </section>

//       {isStay && (
//         <section className="bmt-dashboard-bottom-grid">
//           <article className="bmt-panel-card">
//             <div className="bmt-card-header">
//               <div><h3>{title ? `${title} Setup` : "Property Setup"}</h3><p>Complete important property content</p></div>
//               <span className="bmt-new-badge">NEW</span>
//             </div>
//             <div className="bmt-action-list">
//               {setupActions.map(([target, label]) => (
//                 <button key={`${target}-${label}`} onClick={() => onNavigate(target)}>
//                   <span>{label}</span><b>›</b>
//                 </button>
//               ))}
//             </div>
//           </article>
//           <article className="bmt-panel-card">
//             <div className="bmt-card-header"><div><h3>Today's Snapshot</h3><p>Quick operational summary</p></div></div>
//             <div className="bmt-snapshot-grid">
//               <div><strong>0</strong><span>Pending</span></div>
//               <div><strong>0</strong><span>Confirmed</span></div>
//               <div><strong>0</strong><span>Cancelled</span></div>
//               <div><strong>0</strong><span>Completed</span></div>
//             </div>
//           </article>
//         </section>
//       )}
//     </div>
//   );
// }

// /* ==================== PAGE COMPONENTS ==================== */

// function Intro({ eyebrow, title, text, extra }) {
//   return (
//     <div className="bmt-section-intro">
//       <div><span className="bmt-eyebrow">{eyebrow}</span><h2>{title}</h2><p>{text}</p></div>
//       {extra}
//     </div>
//   );
// }

// function FormActions({ saveLabel }) {
//   return (
//     <div className="bmt-form-actions">
//       <button className="bmt-secondary-btn">Save Draft</button>
//       <button className="bmt-primary-btn">{saveLabel}</button>
//     </div>
//   );
// }

// function Field({ label, placeholder, type = "text" }) {
//   return <div className="bmt-field-group"><label>{label}</label><input type={type} placeholder={placeholder} /></div>;
// }

// function SelectField({ label, options }) {
//   return (
//     <div className="bmt-field-group">
//       <label>{label}</label>
//       <select defaultValue=""><option value="" disabled>Select</option>{options.map((o) => <option key={o}>{o}</option>)}</select>
//     </div>
//   );
// }

// function PropertyMedia() {
//   const [images, setImages] = useState([]);
//   const [videos, setVideos] = useState([]);
//   const [videoUrl, setVideoUrl] = useState("");
//   const toItems = (event) =>
//     Array.from(event.target.files || []).map((file) => ({ file, url: URL.createObjectURL(file), name: file.name }));

//   return (
//     <div className="bmt-premium-page">
//       <Intro
//         eyebrow="PROPERTY CONTENT"
//         title="Images & Videos"
//         text="Add high-quality property photos, room photos, exterior images, facilities, dining images and walkthrough videos."
//         extra={<span className="bmt-completion-pill">Media completeness 0%</span>}
//       />
//       <div className="bmt-property-grid">
//         <section className="bmt-form-card">
//           <div className="bmt-form-card-head"><h3>Property Images</h3><p>Recommended: minimum 8 clear landscape photos.</p></div>
//           <label className="bmt-upload-zone">
//             <input type="file" accept="image/*" multiple onChange={(e) => setImages((p) => [...p, ...toItems(e)])} />
//             <span className="bmt-upload-icon">＋</span>
//             <strong>Upload property images</strong>
//             <small>JPG, PNG, WEBP • Front view, rooms, lobby, washroom, dining and facilities</small>
//           </label>
//           {images.length > 0 && (
//             <div className="bmt-media-grid">
//               {images.map((img, i) => (
//                 <div className="bmt-media-item" key={`${img.name}-${i}`}>
//                   <img src={img.url} alt={img.name} />
//                   <button onClick={() => setImages((p) => p.filter((_, x) => x !== i))}>Remove</button>
//                 </div>
//               ))}
//             </div>
//           )}
//         </section>

//         <section className="bmt-form-card">
//           <div className="bmt-form-card-head"><h3>Property Videos</h3><p>Upload walkthrough videos or add a video URL.</p></div>
//           <label className="bmt-upload-zone compact">
//             <input type="file" accept="video/*" multiple onChange={(e) => setVideos((p) => [...p, ...toItems(e)])} />
//             <span className="bmt-upload-icon">▶</span>
//             <strong>Upload property video</strong>
//             <small>MP4 / WEBM recommended</small>
//           </label>
//           <div className="bmt-field-group">
//             <label>Video URL</label>
//             <div className="bmt-inline-input">
//               <input value={videoUrl} onChange={(e) => setVideoUrl(e.target.value)} placeholder="https://youtube.com/... or property video URL" />
//               <button type="button">Add URL</button>
//             </div>
//           </div>
//           {videos.length > 0 && (
//             <div className="bmt-media-grid video-grid">
//               {videos.map((v, i) => (
//                 <div className="bmt-media-item" key={`${v.name}-${i}`}>
//                   <video src={v.url} controls />
//                   <button onClick={() => setVideos((p) => p.filter((_, x) => x !== i))}>Remove</button>
//                 </div>
//               ))}
//             </div>
//           )}
//         </section>
//       </div>
//     </div>
//   );
// }

// function PropertyAmenities() {
//   const amenities = [
//     "Free Wi-Fi", "Parking", "Air Conditioning", "Restaurant", "Room Service", "Swimming Pool", "Gym", "Spa",
//     "Airport Transfer", "24x7 Front Desk", "Power Backup", "Lift / Elevator", "Laundry", "Pet Friendly",
//     "Wheelchair Accessible", "EV Charging",
//   ];
//   const [selected, setSelected] = useState([]);
//   const toggle = (name) => setSelected((p) => (p.includes(name) ? p.filter((x) => x !== name) : [...p, name]));

//   return (
//     <div className="bmt-premium-page">
//       <Intro eyebrow="PROPERTY INFORMATION" title="Amenities & Facilities" text="Select all facilities available at the property." />
//       <section className="bmt-form-card">
//         <div className="bmt-check-grid">
//           {amenities.map((item) => (
//             <label className={`bmt-check-card ${selected.includes(item) ? "selected" : ""}`} key={item}>
//               <input type="checkbox" checked={selected.includes(item)} onChange={() => toggle(item)} />
//               <span>{item}</span>
//             </label>
//           ))}
//         </div>
//         <FormActions saveLabel="Save Amenities" />
//       </section>
//     </div>
//   );
// }

// function PropertyLocation() {
//   return (
//     <div className="bmt-premium-page">
//       <Intro eyebrow="PROPERTY INFORMATION" title="Location & Contact" text="Keep the exact map location and guest-facing contact details updated." />
//       <section className="bmt-form-card">
//         <div className="bmt-form-grid">
//           <Field label="Address line 1" placeholder="Property address" />
//           <Field label="Address line 2" placeholder="Area / Landmark" />
//           <Field label="City" placeholder="City" />
//           <Field label="State / Province" placeholder="State / Province" />
//           <Field label="Postal Code" placeholder="Postal code" />
//           <Field label="Country" placeholder="Country" />
//           <Field label="Latitude" placeholder="e.g. 27.4924" />
//           <Field label="Longitude" placeholder="e.g. 77.6737" />
//           <Field label="Property Phone" placeholder="+91..." />
//           <Field label="Property Email" placeholder="property@example.com" />
//         </div>
//         <div className="bmt-map-placeholder"><span>Map preview</span><small>Connect Google Maps / Mapbox later with your API key.</small></div>
//         <FormActions saveLabel="Save Location" />
//       </section>
//     </div>
//   );
// }

// function PropertyPolicies() {
//   return (
//     <div className="bmt-premium-page">
//       <Intro eyebrow="PROPERTY INFORMATION" title="Policies & House Rules" text="Define check-in, check-out, cancellation, child and guest rules." />
//       <section className="bmt-form-card">
//         <div className="bmt-form-grid">
//           <Field label="Check-in from" type="time" />
//           <Field label="Check-out until" type="time" />
//           <SelectField label="Children allowed?" options={["Yes", "No", "On request"]} />
//           <SelectField label="Pets allowed?" options={["No", "Yes", "On request"]} />
//           <SelectField label="Smoking" options={["Not allowed", "Designated area only", "Allowed"]} />
//           <SelectField label="Unmarried couples" options={["Allowed", "Not allowed", "Subject to ID verification"]} />
//         </div>
//         <div className="bmt-field-group"><label>Cancellation Policy</label><textarea rows="5" placeholder="Describe cancellation and no-show rules..." /></div>
//         <div className="bmt-field-group"><label>House Rules</label><textarea rows="5" placeholder="Add important guest rules..." /></div>
//         <FormActions saveLabel="Save Policies" />
//       </section>
//     </div>
//   );
// }

// function PropertyDocuments() {
//   const docs = ["Business Registration", "Tax Registration", "Property License", "Owner / Authorized ID", "Bank Proof", "Fire / Safety Certificate"];
//   return (
//     <div className="bmt-premium-page">
//       <Intro eyebrow="VERIFICATION" title="Documents & Verification" text="Upload and track documents required to keep your property live." />
//       <section className="bmt-form-card">
//         <div className="bmt-document-list">
//           {docs.map((doc) => (
//             <div className="bmt-document-row" key={doc}>
//               <div><strong>{doc}</strong><span>Not uploaded</span></div>
//               <label className="bmt-upload-small">Upload<input type="file" /></label>
//             </div>
//           ))}
//         </div>
//       </section>
//     </div>
//   );
// }

// function PropertyHighlights() {
//   const [highlights, setHighlights] = useState(["Near major attractions", "Family friendly"]);
//   const [value, setValue] = useState("");
//   const add = () => {
//     const next = value.trim();
//     if (!next) return;
//     setHighlights((p) => [...p, next]);
//     setValue("");
//   };

//   return (
//     <div className="bmt-premium-page">
//       <Intro eyebrow="CONTENT QUALITY" title="Highlights & USPs" text="Add the strongest reasons a guest should choose your property." />
//       <section className="bmt-form-card">
//         <div className="bmt-field-group">
//           <label>Property short description</label>
//           <textarea rows="6" placeholder="Write a clear, premium guest-facing property description..." />
//         </div>
//         <div className="bmt-field-group">
//           <label>Add highlight</label>
//           <div className="bmt-inline-input">
//             <input value={value} onChange={(e) => setValue(e.target.value)} placeholder="e.g. 2 minutes from the beach" />
//             <button type="button" onClick={add}>Add</button>
//           </div>
//         </div>
//         <div className="bmt-chip-wrap">
//           {highlights.map((item, i) => (
//             <span className="bmt-chip" key={`${item}-${i}`}>
//               {item}
//               <button onClick={() => setHighlights((p) => p.filter((_, x) => x !== i))}>×</button>
//             </span>
//           ))}
//         </div>
//         <FormActions saveLabel="Save Content" />
//       </section>
//     </div>
//   );
// }

// function AnalyticsPage() {
//   const cards = [["Revenue", "₹0", "+0%"], ["Room Nights", "0", "+0%"], ["Average Selling Price", "₹0", "+0%"], ["Conversion", "0%", "+0%"]];
//   return (
//     <div className="bmt-premium-page">
//       <Intro eyebrow="PERFORMANCE" title="Analytics" text="Property performance overview for bookings, revenue and conversion." />
//       <div className="bmt-analytics-cards">
//         {cards.map(([title, value, trend]) => (
//           <article key={title}><span>{title}</span><strong>{value}</strong><small>{trend} vs previous period</small></article>
//         ))}
//       </div>
//       <section className="bmt-form-card">
//         <div className="bmt-chart-placeholder"><strong>Performance chart</strong><span>Connect this section to your analytics API data.</span></div>
//       </section>
//     </div>
//   );
// }

// function SimplePremiumPage({ title, description }) {
//   return (
//     <div className="bmt-premium-page">
//       <Intro eyebrow="BIRDMYTRIP PARTNER" title={title} text={description} />
//       <section className="bmt-form-card">
//         <div className="bmt-empty-state">
//           <div className="bmt-empty-icon">✦</div>
//           <h3>{title}</h3>
//           <p>Frontend section is ready. Connect this screen to the matching BirdMyTrip backend API when available.</p>
//           <button className="bmt-primary-btn">Get Started</button>
//         </div>
//       </section>
//     </div>
//   );
// }


import React, { useEffect, useMemo, useState } from "react";
import VendorHotels from "./VendorHotels";
import HotelDashboard from "./Hoteldashboard";
import VendorCabs from "./VendorCabs";
import VendorCabDrivers from "./VendorCabDrivers";
import CabVendorDashboard from "./CabVendorDashboard";
import HostelManager from "./hostel/HostelManager";
import HostelRoomManager from "./hostel/Hostelroommanager";
import BusModule from "./BusModule";
import BusTripModule from "./BusTripModule";
import BusSeatLayoutModule from "./BusSeatLayoutModule";
import VendorBusBookings from "./VendorBusBookings";
import VendorCabBookings from "./VendorCabBookings";
import VendorHotelBookings from "./VendorHotelBookings";
import VendorHotelRooms from "./Vendorhotelrooms";
import VendorRoomInventory from "./Vendorroominventory";
import VillaManager from "../pages/villa/VillaManager";
import VillaRoomManager from "./villa/VillaRoomManager";
import Villaroominventory from "../pages/villa/Villaroominventory";
import Villaroompricing from "../pages/villa/Villaroompricing";
import VillaBookings from "./villa/Villabooking";
import VendorApartment from "./Vendorapartment";
import VendorApartmentInventory from "../pages/Apartment/Vendorapartmentinventory";
import VendorHomestay from "./VendorHomestay";
import Homestayunitmanager from "./Homestayunitmanager";
import VendorHomestayInventory from "./VendorHomestayInventory";
import HomestayDashboard from "./Homestaydashboard";
import VendorHomestayBookings from "./VendorHomestayBookings";
import AddDarshan from "./darshan/AddDarshan";
import Darshantype from "./darshan/Darshantype";
import Darshanslot from "./darshan/Darshanslot";
import DarshanDashboard from "./darshan/Darshandashboard";
import Darshanavailability from "./darshan/Darshanavailability";
import DarshanBookings from "./darshan/Vendordarshanbookings";
import VendorHoliday from "./VendorHoliday";
import VendorHolidayBookings from "./VendorHolidayBookings";
import VendorBnb from "./Bnbmanager";
import Palaceapp from "./Palaceapp";
import AddPlace from "./Place/addPlace";
import PalaceRoomCategories from "../pages/Place/PalaceRoomCategories";
import PalaceAnalytics from "./Place/PalaceAnalytics";
import PalaceRoomUnits from "./Place/PalaceRoomUnits";
import PalaceInventory from "./Place/PalaceInventory";
import PalaceRatePlans from "./Place/PalaceRatePlans";
import PalaceBookings from "./Place/PalaceBookings";
import VendorRatingsReviews from "../pages/VendorRatingsReviews";
import VendorOffers from "../pages/Place/VendorOffers";
import VendorAdvertisements from "../pages/Place/VendorAdvertisements";
import VendorVacationHouse from "./Vacationhouseapp";
import NightclubManagement from "./NightClub/NightclubManagement";
import NightclubBookings from "./NightClub/Nightclubbookings";
// FIX: pehle "../pages/NightClub/Nightclubdashboard" tha (galat path) -> component undefined aa raha tha
import NightclubDashboard from "./NightClub/Nightclubdashboard";
import NightclubTables from "./NightClub/Nightclubtables";
import NightclubTablePricing from "./NightClub/Nightclubtablepricing";
import ManageEvents from "./NightClub/ManageEvents";
import EventTickets from "./NightClub/EventTickets";
import { BnbBooking } from "./bnbBooking/BnbBooking";
import VendorProfile from "./VendorProfile";
import VendorSupport from "../pages/Place/VendorSupport";
import VendorPolicies from "../pages/Place/VendorPolicies";
import VendorCruise from "./VendorCruise";
import CabinManagement from "./CabinManagement";
import CruiseItineraryManagement from "./CruiseItineraryManagement";
import CruiseBookingsManagement from "./CruiseBookingsManagement";
import CruiseSailingManagement from "./CruiseSailingManagement";
import CruiseDashboard from "./Cruisedashboard";
import Tours from "./tours-activities/Tours";
import TourBookings from "./tours-activities/Tourbookings";
import TourQuery from "./tours-activities/TourQuery";
import TourReview from "./tours-activities/TourReview";
import TourSchedule from "./tours-activities/TourSchedule";
import AddActivities from "./Activities/AddActivities";
import ScheduleActivities from "./Activities/ScheduleActivities";
import ActivitiesBookings from "./Activities/ActivitiesBookings";
import AddResort from "./Resort/addResort";
import ResortRooms from "./Resort/Resortrooms";
import ResortRoomUnits from "./Resort/ResortRoomUnits";
import ResortPricing from "./Resort/Resortpricing";
import ResortInventory from "./Resort/Resortinventory";
import ResortBookings from "./Resort/Resortbookings";
import ResortReviews from "./Resort/Resortreviews";
import VendorApartmentRatePlans from "../pages/Apartment/Vendorapartmentrateplans";
import VendorApartmentBookings from "../pages/Apartment/Vendorapartmentbookings";
import "./VendorCruise.css";
import "./VendorLayout.css";

/* ==================== ICONS & MENU HELPERS ==================== */

const IC = {
  dash: "▦", book: "▤", inv: "▥", prop: "⌂", bed: "▭", img: "▧", star: "☆", pin: "⌖", doc: "▢",
  chart: "⌁", ship: "⚓", map: "◫", plus: "＋", price: "$", car: "◉", user: "☺", bus: "▣", seat: "▤",
  tour: "✈", ev: "◆", club: "♪", pray: "◇", gear: "⚙", crown: "♛",
  grow: "✦", pay: "◈", ad: "AD", eye: "◎", camp: "✦",
};
const L = (list) => list.map(([id, label, icon]) => ({ id, label, icon: IC[icon] }));
const D = ["dashboard", "Dashboard", "dash"];

/* ==================== PANELS (har service ka apna panel) ==================== */

const PANELS = {
  hotel: {
    title: "Hotel", icon: IC.prop,
    main: L([
      D,
      ["hotels_bookings", "Bookings", "book"],
      ["hotel_room_inventory", "Rates & Inventory", "inv"],
      ["hotels_manage", "Property Details", "prop"],
      ["hotel_rooms", "Rooms & Units", "bed"],
    ]),
  },
  homestay: {
    title: "Homestay", icon: IC.prop,
    main: L([
      D,
      ["homestays_bookings", "Bookings", "book"],
      ["homestay_inventory", "Rates & Inventory", "inv"],
      ["homestays_manage", "Property Details", "prop"],
      ["homestay_units", "Units / Rooms", "bed"],
    ]),
  },
  resort: {
    title: "Resort", icon: IC.prop,
    main: L([
      D,
      ["resort_manage", "My Resorts", "prop"],
      ["resort_rooms", "Rooms & Categories", "bed"],
      ["resort_bookings", "Bookings", "book"],
      ["resort_units", "Room Units", "seat"],
      ["resort_inventory", "Availability", "inv"],
      ["resort_pricing", "Rates & Pricing", "inv"],
      ["analytics", "Analytics", "chart"],
    ]),
  },
  cruise: {
    title: "Cruise", icon: IC.ship,
    main: L([
      D,
      ["cruise_manage", "My Cruises", "ship"],
      ["cruise_cabins", "Cabin Management", "bed"],
      ["cruise_itineraries", "Itinerary Management", "map"],
      ["cruise_sailings", "Sailing Management", "ship"],
      ["cruise_add", "Add Cruise", "plus"],
      ["cruise_bookings", "Bookings", "book"],
    ]),
  },
  cab: {
    title: "Cab", icon: IC.car,
    main: L([
      D,
      ["cabs_manage", "Manage Cabs", "car"],
      ["cabs_drivers", "Driver Management", "user"],
      ["cabs_bookings", "Cab Bookings", "book"],
    ]),
  },
  bus: {
    title: "Bus", icon: IC.bus,
    main: L([
      D,
      ["buses_manage", "Manage Buses", "bus"],
      ["bus_trip_module", "Trip Management", "map"],
      ["bus_seat_layout", "Seat Layout", "seat"],
      ["buses_bookings", "Bus Bookings", "book"],
    ]),
  },
  tours: {
    title: "Tours", icon: IC.tour,
    main: L([
      D,
      ["tours_manage", "Manage Tours", "tour"],
      ["tours_bookings", "Tour Bookings", "book"],
      ["tours_queries", "Tour Queries", "doc"],
      ["tours_reviews", "Tour Reviews", "star"],
      ["tours_schedule", "Tour Schedules", "map"],
    ]),
  },
  activities: {
    title: "Activities", icon: IC.ev,
    main: L([
      D,
      ["activities_manage", "Manage Activities", "ev"],
      ["activities_schedule", "Activity Schedules", "map"],
      ["activities_bookings", "Activity Bookings", "book"],
    ]),
  },
  events: {
    title: "Events", icon: IC.ev,
    main: L([
      D,
      ["events_manage", "Manage Events", "ev"],
      ["events_tickets", "Event Tickets", "book"],
      ["events_nightclub", "Night Club", "club"],
      ["nightclub_tables", "Tables", "seat"],
      ["nightclub_table_pricing", "Table Pricing", "price"],
      ["nightclub_bookings", "Event Bookings", "book"],
    ]),
  },
  nightclub: {
    title: "Night Club", icon: IC.club,
    main: L([
      D,
      ["nightclub_manage", "Manage Night Club", "club"],
      ["nightclub_tables", "Tables", "seat"],
      ["nightclub_table_pricing", "Table Pricing", "price"],
      ["nightclub_bookings", "Bookings", "book"],
    ]),
  },
  darshan: {
    title: "Darshan", icon: IC.pray,
    main: L([
      D,
      ["darshan_add", "Add Darshan", "plus"],
      ["darshan_types", "Darshan Types", "tour"],
      ["darshan_slots", "Darshan Slots", "seat"],
      ["darshan_availability", "Slot Availability", "inv"],
      ["darshan_bookings", "Bookings", "book"],
    ]),
  },
  holidays: {
    title: "Holidays", icon: IC.tour,
    main: L([D, ["holidays_manage", "Manage Holidays", "tour"], ["holidays_bookings", "Holiday Bookings", "book"]]),
  },
  bnb: {
    title: "BnB", icon: IC.prop,
    main: L([D, ["bnb_manage", "Manage BnB", "prop"], ["bnb_bookings", "BnB Bookings", "book"]]),
  },
  palace: {
    title: "Palace", icon: IC.crown,
    main: L([
      D,
      ["palace_manage", "My Palaces", "crown"],
      ["palace_room_categories", "Palace Room Categories", "bed"],
      ["palace_room_units", "Room Units", "seat"],
      ["palace_inventory", "Room Inventory", "inv"],
      ["palace_rate_plans", "Rate Plans & Pricing", "price"],
      ["palace_bookings", "Palace Bookings", "book"],
      ["palace_analytics", "Analytics", "chart"],
    ]),
  },
  vacation: {
    title: "Vacation House", icon: IC.prop,
    main: L([D, ["vacationhouses_manage", "Manage Houses", "prop"], ["vacationhouses_bookings", "Bookings", "book"]]),
  },
  villa: {
    title: "Villa", icon: IC.prop,
    main: L([
      D,
      ["villa_manage", "Manage Villas", "prop"],
      ["villa_rooms", "Villa Rooms", "bed"],
      ["villa_inventory", "Room Inventory", "inv"],
      ["villa_pricing", "Room Pricing", "inv"],
      ["villa_bookings", "Villa Bookings", "book"],
    ]),
  },
  apartments: {
  title: "Apartments",
  icon: IC.prop,
  main: L([
    D,
    ["apartments_manage", "Manage Apartments", "prop"],
    ["apartments_inventory", "Apartment Inventory", "inv"],
    ["apartments_rateplans", "Rate Plans & Pricing", "price"],
    ["apartments_bookings", "Apartment Bookings", "booking"],
  ]),
},
  partner: { title: "Partner", icon: IC.dash, main: L([D]) },
};

Object.keys(PANELS).forEach((k) => {
  PANELS[k] = { ...PANELS[k], base: k };
});

/* ==================== NAYE STAY SUBTYPES ====================
   Har subtype ka apna dashboard, apna menu, apne tab ids (motel_*, hostel_* ...).
   Jis page ka component bana nahi, wahan khali naya page khulta hai.
   Naya menu item add karna ho -> us subtype ke `extra` mein add karo.
============================================================ */

const STAY_SUBTYPES = {
  hostel: {
    title: "Hostel", icon: IC.bed, unit: "Bed Nights", occupancy: "Beds occupied tonight",
    banner: "Track bed nights, dorm and private room occupancy, revenue per bed and check-ins.",
    setup: ["Add or Edit Hostel Details", "Add Dorms & Private Rooms", "Set Bed Rates & Availability", "Review House Rules & Check-in Times"],
    snapshot: ["Pending", "Confirmed", "Beds Available", "Checked-out"],
    extra: [],
  },
  motel: {
    title: "Motel", icon: IC.prop, unit: "Room Nights", occupancy: "Rooms occupied tonight",
    banner: "Track room nights, drive-in bookings, revenue and check-ins for your motel.",
    setup: ["Add or Edit Motel Details", "Add Rooms & Parking Info", "Set Room Rates & Availability", "Review Policies & Check-in Times"],
    snapshot: ["Pending", "Confirmed", "Rooms Available", "Checked-out"],
    extra: [],
  },
  lodge: {
    title: "Lodge", icon: IC.prop, unit: "Room Nights", occupancy: "Rooms occupied tonight",
    banner: "Track room nights, revenue and check-ins for your lodge.",
    setup: ["Add or Edit Lodge Details", "Add Rooms & Cottages", "Set Rates & Availability", "Review Policies & Check-in Times"],
    snapshot: ["Pending", "Confirmed", "Rooms Available", "Checked-out"],
    extra: [],
  },
  inn: {
    title: "Inn", icon: IC.prop, unit: "Room Nights", occupancy: "Rooms occupied tonight",
    banner: "Track room nights, revenue and check-ins for your inn.",
    setup: ["Add or Edit Inn Details", "Add Rooms", "Set Rates & Availability", "Review Policies & Check-in Times"],
    snapshot: ["Pending", "Confirmed", "Rooms Available", "Checked-out"],
    extra: [],
  },
  guesthouse: {
    title: "Guest House", icon: IC.prop, unit: "Room Nights", occupancy: "Rooms occupied tonight",
    banner: "Track guest bookings, room nights, revenue and check-ins for your guest house.",
    setup: ["Add or Edit Guest House Details", "Add Rooms", "Set Rates & Availability", "Review House Rules & Check-in Times"],
    snapshot: ["Pending", "Confirmed", "Rooms Available", "Checked-out"],
    extra: [],
  },
  farmstay: {
    title: "Farm Stay", icon: IC.prop, unit: "Stay Nights", occupancy: "Units occupied tonight",
    banner: "Track stay nights, revenue and check-ins for your farm stay.",
    setup: ["Add or Edit Farm Stay Details", "Add Rooms / Cottages", "Set Rates & Availability", "Review Rules & Check-in Times"],
    snapshot: ["Pending", "Confirmed", "Units Available", "Checked-out"],
    extra: [],
  },
  campsite: {
    title: "Campsite", icon: IC.camp, unit: "Camp Nights", occupancy: "Tents / pitches occupied tonight",
    banner: "Track camp nights, tent occupancy, revenue and check-ins for your campsite.",
    setup: ["Add or Edit Campsite Details", "Add Tents & Pitches", "Set Rates & Availability", "Review Safety Rules & Check-in Times"],
    snapshot: ["Pending", "Confirmed", "Tents Available", "Checked-out"],
    extra: [],
  },
  camp: {
    title: "Camp", icon: IC.camp, unit: "Camp Nights", occupancy: "Tents occupied tonight",
    banner: "Track camp nights, tent occupancy, revenue and check-ins for your camp.",
    setup: ["Add or Edit Camp Details", "Add Tents", "Set Rates & Availability", "Review Safety Rules & Check-in Times"],
    snapshot: ["Pending", "Confirmed", "Tents Available", "Checked-out"],
    extra: [],
  },
  "serviced-apartment": {
    title: "Serviced Apartment", icon: IC.prop, unit: "Apartment Nights", occupancy: "Apartments occupied tonight",
    banner: "Track apartment nights, long-stay bookings, revenue and check-ins.",
    setup: ["Add or Edit Apartment Details", "Add Apartment Units", "Set Rates & Availability", "Review Policies & Check-in Times"],
    snapshot: ["Pending", "Confirmed", "Apartments Available", "Checked-out"],
    extra: [],
  },
};

/*
  REAL PAGES ADD KARNE KI JAGAH
  Tab id format: `${subtypeKey}_bookings | _inventory | _manage | _rooms`
  Example:
    import MotelBookings from "./motel/MotelBookings";
    motel_bookings: <MotelBookings />,
  Jo yahan nahi hoga, wahan khali "naya page" dikhega.
*/
const CUSTOM_PAGES = {
  hostel_manage: <HostelManager />,
  hostel_rooms: <HostelRoomManager />,
  // motel_bookings: <MotelBookings />,
  // motel_rooms: <MotelRooms />,
  // hostel_bookings: <HostelBookings />,
};

const SUBTYPE_PANELS = {};
Object.entries(STAY_SUBTYPES).forEach(([k, s]) => {
  const menu = [
    D,
    [`${k}_bookings`, "Bookings", "book"],
    [`${k}_inventory`, "Rates & Inventory", "inv"],
    [`${k}_manage`, `${s.title} Details`, "prop"],
    [`${k}_rooms`, "Rooms & Units", "bed"],
    ...s.extra,
  ];
  PANELS[k] = { title: s.title, icon: s.icon, base: k, main: L(menu) };
  SUBTYPE_PANELS[k] = true;
});

/* ==================== ACCOUNT / COMMON MENU ==================== */

const ACCOUNT = L([
  ["profile_personal", "My Profile", "user"],
  ["profile_business", "Business Details", "prop"],
  ["profile_contact", "Contact Details", "pin"],
  ["profile_tax", "Tax & Identity", "doc"],
  ["profile_bank", "Bank Details", "pay"],
  ["profile_service", "Service Details", "gear"],
  ["settings", "Settings", "gear"],
]);

const COMMON_VENDOR_MENU = L([
  ["vendor_offers", "Offers & Promotions", "grow"],
  ["vendor_advertisements", "Advertisements", "ad"],
  ["vendor_support", "Support", "doc"],
  ["vendor_ratings_reviews", "Ratings & Reviews", "star"],
  ["vendor_policies", "Privacy & Policies", "gear"],
]);

/* ==================== ALIASES: har service apne hi key par ==================== */

const normalizeService = (value) =>
  String(value || "")
    .trim()
    .toLowerCase()
    .replace(/[_\s]+/g, "-")
    .replace(/-+/g, "-");

const ALIASES = {
  hotel: "hotel", hotels: "hotel",
  motel: "motel", motels: "motel",
  lodge: "lodge", lodges: "lodge",
  inn: "inn", inns: "inn",
  homestay: "homestay", homestays: "homestay", "home-stay": "homestay",
  hostel: "hostel", hostels: "hostel",
  guesthouse: "guesthouse", guesthouses: "guesthouse", "guest-house": "guesthouse",
  farmstay: "farmstay", farmstays: "farmstay", "farm-stay": "farmstay",
  farmhouse: "farmstay", "farm-house": "farmstay",
  campsite: "campsite", campsites: "campsite", "camp-site": "campsite",
  camp: "camp", camps: "camp",
  resort: "resort", resorts: "resort",
  palace: "palace", palaces: "palace",
  bnb: "bnb", "bed-and-breakfast": "bnb", "bed-breakfast": "bnb", "b-and-b": "bnb", stay: "bnb",
  apartment: "apartments", apartments: "apartments",
  "serviced-apartment": "serviced-apartment", "serviced-apartments": "serviced-apartment",
  "vacation-house": "vacation", "vacation-home": "vacation", "vacation-homes": "vacation",
  vacation: "vacation", vacationhouse: "vacation",
  villa: "villa", villas: "villa",

  cab: "cab", cabs: "cab", "car-rental": "cab",
  bus: "bus", buses: "bus",
  cruise: "cruise", cruises: "cruise",
  package: "tours", packages: "tours", tours: "tours", tour: "tours",
  activity: "activities", activities: "activities",
  events: "events", event: "events",
  darshan: "darshan", darshans: "darshan", "bmt-darshan": "darshan",
  holiday: "holidays", holidays: "holidays",
  nightclub: "nightclub", nightclubs: "nightclub", "night-club": "nightclub",
};

/* ==================== SIMPLE (placeholder) PAGES ==================== */

const SIMPLE_PAGES = {
  promotions: ["Promotions & Offers", "Create property discounts, mobile offers, early-bird offers and limited-time deals."],
  visibility_boost: ["Visibility Booster", "Improve property visibility with sponsored placement and performance campaigns."],
  campaigns: ["Campaigns", "Manage seasonal campaigns and marketing participation."],
  payments: ["Payments", "View settlements, payment status, deductions and payout history."],
  sponsored: ["Sponsored Listing", "Boost your property ranking through paid sponsored placement."],
  ratings_reviews: ["Ratings & Reviews", "Track guest ratings, review reasons and respond to guest feedback."],
  events_bookings: ["Event Bookings", "View and manage bookings received for your events."],
  vacationhouses_bookings: ["Vacation House Bookings", "Manage upcoming, completed and cancelled reservations."],
  cruise_pricing: ["Pricing Management", "Set cabin prices and seasonal rates for your sailings."],
  settings: ["Settings", "Manage your account preferences."],
};

const PROFILE_SECTIONS = {
  profile_personal: "personal",
  profile_business: "business",
  profile_contact: "contact",
  profile_tax: "tax",
  profile_bank: "bank",
  profile_service: "service",
};

/* ==================== TAB -> PAGE MAP ==================== */

const PAGES = {
  vendor_offers: <VendorOffers />,
  vendor_advertisements: <VendorAdvertisements />,
  vendor_support: <VendorSupport />,
  vendor_policies: <VendorPolicies />,
  vendor_ratings_reviews: <VendorRatingsReviews />,
  // Hotel
  hotels_manage: <VendorHotels />,
  hotel_rooms: <VendorHotelRooms />,
  hotel_room_inventory: <VendorRoomInventory />,
  hotels_bookings: <VendorHotelBookings />,
  // Homestay
  homestays_manage: <VendorHomestay />,
  homestay_units: <Homestayunitmanager />,
  homestay_inventory: <VendorHomestayInventory />,
  homestays_bookings: <VendorHomestayBookings />,
  // Resort
  resort_manage: <AddResort />,
  resort_rooms: <ResortRooms />,
  resort_units: <ResortRoomUnits />,
  resort_pricing: <ResortPricing />,
  resort_bookings: <ResortBookings />,
  resort_reviews: <ResortReviews />,
  resort_inventory: <ResortInventory />,
  // Shared property info
  property_media: <PropertyMedia />,
  property_amenities: <PropertyAmenities />,
  property_location: <PropertyLocation />,
  property_policies: <PropertyPolicies />,
  property_documents: <PropertyDocuments />,
  property_highlights: <PropertyHighlights />,
  analytics: <AnalyticsPage />,
  // BnB / Apartments
  bnb_manage: <VendorBnb />,
  bnb_bookings: <BnbBooking />,
  apartments_manage: <VendorApartment />,
  apartments_inventory: <VendorApartmentInventory />,
  apartments_rateplans: <VendorApartmentRatePlans />,
  apartments_bookings: <VendorApartmentBookings />,
  // Cab
  cabs_manage: <VendorCabs />,
  cabs_drivers: <VendorCabDrivers />,
  cabs_bookings: <VendorCabBookings />,
  // Bus
  buses_manage: <BusModule />,
  bus_trip_module: <BusTripModule />,
  bus_seat_layout: <BusSeatLayoutModule />,
  buses_bookings: <VendorBusBookings />,
  // Cruise
  cruise_manage: <VendorCruise />,
  cruise_add: <VendorCruise />,
  cruise_cabins: <CabinManagement />,
  cruise_itineraries: <CruiseItineraryManagement />,
  cruise_bookings: <CruiseBookingsManagement />,
  cruise_sailings: <CruiseSailingManagement />,
  // Tours
  tours_manage: <Tours />,
  tours_bookings: <TourBookings />,
  tours_queries: <TourQuery />,
  tours_reviews: <TourReview />,
  tours_schedule: <TourSchedule />,
  // Activities
  activities_manage: <AddActivities />,
  activities_schedule: <ScheduleActivities />,
  activities_bookings: <ActivitiesBookings />,
  // Events / Night club
  events_manage: <ManageEvents />,
  events_tickets: <EventTickets />,
  nightclub_manage: <NightclubManagement />,
  events_nightclub: <NightclubManagement />,
  nightclub_dashboard: <NightclubDashboard />,
  nightclub_tables: <NightclubTables />,
  nightclub_bookings: <NightclubBookings />,
  nightclub_table_pricing: <NightclubTablePricing />,
  // Darshan
  darshan_add: <AddDarshan />,
  darshan_types: <Darshantype />,
  darshan_slots: <Darshanslot />,
  darshan_availability: <Darshanavailability />,
  darshan_bookings: <DarshanBookings />,
  // Villa
  villa_manage: <VillaManager />,
  villa_rooms: <VillaRoomManager />,
  villa_inventory: <Villaroominventory />,
  villa_pricing: <Villaroompricing />,
  villa_bookings: <VillaBookings />,
  // Palace
  palace_manage: <AddPlace />,
  palace_rooms: <Palaceapp />,
  palace_room_categories: <PalaceRoomCategories />,
  palace_room_units: <PalaceRoomUnits />,
  palace_inventory: <PalaceInventory />,
  palace_rate_plans: <PalaceRatePlans />,
  palace_bookings: <PalaceBookings />,
  palace_analytics: <PalaceAnalytics />,
  // Others
  vacationhouses_manage: <VendorVacationHouse />,
  holidays_manage: <VendorHoliday />,
  holidays_bookings: <VendorHolidayBookings />,
};

/* ==================== DASHBOARD SHORTCUTS ==================== */

const STAY_PANELS = ["hotel", "homestay", "resort", "bnb", "palace", "vacation", "villa", "apartments"];

const BOOKING_TARGET = {
  hotel: "hotels_bookings", homestay: "homestays_bookings", resort: "resort_bookings",
  bnb: "bnb_bookings", vacation: "vacationhouses_bookings", villa: "villa_bookings",
  palace: "palace_bookings", apartments: "apartments_manage", bus: "buses_bookings",
  cab: "cabs_bookings", activities: "activities_bookings", darshan: "darshan_bookings",
  tours: "tours_bookings", holidays: "holidays_bookings", cruise: "cruise_bookings",
  events: "events_tickets", nightclub: "nightclub_bookings",
};

const INVENTORY_TARGET = {
  hotel: "hotel_room_inventory", homestay: "homestay_inventory", resort: "resort_inventory",
  palace: "palace_inventory", villa: "villa_inventory", apartments: "apartments_inventory",
  activities: "activities_schedule", darshan: "darshan_availability",
  nightclub: "nightclub_table_pricing", tours: "tours_schedule", bus: "bus_trip_module",
  cab: "cabs_manage", cruise: "cruise_sailings",
};

const SETUP_ACTIONS = {
  resort: [
    ["resort_manage", "Add or Edit Resorts"],
    ["resort_rooms", "Add Room Categories & Prices"],
    ["resort_manage", "Review Policies & Check-in Times"],
    ["resort_units", "Add Room Numbers (Units)"],
    ["resort_pricing", "Set Rate Plans & Date Prices"],
  ],
  palace: [
    ["palace_manage", "Add or Edit Palaces"],
    ["palace_manage", "Upload Gallery & Set Cover Image"],
    ["palace_manage", "Review Policies & Check-in Times"],
    // FIX: "palace_rooms" menu mein nahi hai, isliye click par dashboard par wapas aata tha
    ["palace_room_categories", "Add Rooms, Rates & Inventory"],
  ],
  default: [
    ["property_media", "Add Images & Videos"],
    ["property_amenities", "Update Amenities & Facilities"],
    ["property_policies", "Review Property Policies"],
  ],
};

/* ==================== HELPERS ==================== */

const pathTab = () => {
  const p = typeof window !== "undefined" ? window.location.pathname : "";
  if (p.includes("/vendor/cab/driver") || p.includes("/vendor/cab-driver")) return "cabs_drivers";
  if (p.includes("/vendor/cab/booking")) return "cabs_bookings";
  if (p.includes("/vendor/cab/manage")) return "cabs_manage";
  if (p.includes("/vendor/darshan/add")) return "darshan_add";
  if (p.includes("/vendor/darshan/types")) return "darshan_types";
  if (p.includes("/vendor/darshan/slots")) return "darshan_slots";
  if (p.includes("/vendor/darshan/availability")) return "darshan_availability";
  if (p.includes("/vendor/darshan/bookings")) return "darshan_bookings";
  if (p.includes("/vendor/nightclub/pricing")) return "nightclub_table_pricing";
  if (p.includes("/vendor/nightclub/tables")) return "nightclub_tables";
  return "";
};

const urlStaySubtype = () => {
  if (typeof window === "undefined") return "";
  const m = window.location.pathname.match(/\/vendor\/stay\/([^/]+)/);
  return m ? normalizeService(decodeURIComponent(m[1])) : "";
};

const clearSession = () => {
  localStorage.removeItem("vendorToken");
  localStorage.removeItem("vendorUser");
  sessionStorage.removeItem("bmtVendorActiveTab");
};

function resolveVendorService(vendor) {
  const vertical = normalizeService(vendor.vertical || vendor.selectedVertical || "");
  const fromUrl = urlStaySubtype();

  if (vertical && vertical !== "stay") return vertical;

  const subtype = normalizeService(
    vendor.staySubtype ||
      vendor.business?.staySubtype ||
      vendor.business?.propertyType ||
      vendor.propertyType ||
      vendor.business?.service ||
      vendor.service ||
      ""
  );
  return fromUrl || subtype || "stay";
}

/* ==================== ERROR BOUNDARY ==================== */

class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    console.error("VENDOR PAGE CRASH:", error, info);
  }
  componentDidUpdate(prevProps) {
    if (prevProps.resetKey !== this.props.resetKey && this.state.error) {
      this.setState({ error: null });
    }
  }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 24 }}>
          <h3 style={{ color: "#b91c1c" }}>Is page mein error aaya</h3>
          <pre style={{ whiteSpace: "pre-wrap", fontSize: 13 }}>
            {String(this.state.error?.message || this.state.error)}
          </pre>
        </div>
      );
    }
    return this.props.children;
  }
}

/* ==================== MAIN LAYOUT ==================== */

export default function VendorLayout() {
  const [activeTab, setActiveTab] = useState(
    () => pathTab() || sessionStorage.getItem("bmtVendorActiveTab") || "dashboard"
  );
  const [accountOpen, setAccountOpen] = useState(() =>
    String(pathTab() || sessionStorage.getItem("bmtVendorActiveTab") || "dashboard").startsWith("profile_")
  );
  const [vendorName, setVendorName] = useState("");
  const [vendorService, setVendorService] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("vendorToken");
    const stored = localStorage.getItem("vendorUser");
    if (!token || !stored) {
      clearSession();
      window.location.href = "/vendor-login";
      return;
    }
    try {
      const vendor = JSON.parse(stored);
      setVendorName(
        vendor.business?.businessName ||
          vendor.businessName ||
          vendor.companyName ||
          vendor.name ||
          vendor.ownerName ||
          vendor.email ||
          "Vendor"
      );

      const resolvedService = resolveVendorService(vendor);
      setVendorService(resolvedService);

      if (resolvedService === "cruise" && String(activeTab).startsWith("profile_")) {
        setActiveTab("cruise_manage");
        sessionStorage.setItem("bmtVendorActiveTab", "cruise_manage");
      }
    } catch (error) {
      console.error("VENDOR SESSION ERROR:", error);
      clearSession();
      window.location.href = "/vendor-login";
      return;
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const key = ALIASES[normalizeService(vendorService)] || "partner";
  const panel = PANELS[key] || PANELS.partner;
  const baseKey = panel.base || key;

  const allIds = useMemo(
    () =>
      new Set(
        [...panel.main, ...ACCOUNT, ...COMMON_VENDOR_MENU]
          .map((item) => item.id)
          .concat(Object.keys(PROFILE_SECTIONS))
      ),
    [panel]
  );
  const tab = allIds.has(activeTab) ? activeTab : "dashboard";

  useEffect(() => {
    sessionStorage.setItem("bmtVendorActiveTab", tab);
  }, [tab]);

  const logout = () => {
    if (window.confirm("Are you sure you want to logout?")) {
      clearSession();
      window.location.href = "/vendor-login";
    }
  };

  const renderContent = () => {
    // A. Naye stay subtypes (hostel, motel, lodge ...): apna dashboard + apne pages
    if (SUBTYPE_PANELS[key] && (tab === "dashboard" || tab.startsWith(`${key}_`))) {
      if (tab === "dashboard") {
        return <StayDashboard serviceKey={key} onNavigate={setActiveTab} />;
      }
      return (
        CUSTOM_PAGES[tab] || (
          <NewSubtypePage
            serviceKey={key}
            tabId={tab}
            label={panel.main.find((m) => m.id === tab)?.label || "New Page"}
          />
        )
      );
    }

    // B. Baaki services ke dashboards
    if (tab === "dashboard") {
      switch (key) {
        case "cab":
          return <CabVendorDashboard onNavigate={setActiveTab} />;
        case "homestay":
          return <HomestayDashboard onNavigate={setActiveTab} />;
        case "hotel":
          return <HotelDashboard onNavigate={setActiveTab} />;
        case "cruise":
          return <CruiseDashboard onNavigate={setActiveTab} />;
        case "events":
        case "nightclub":
          return <NightclubDashboard onNavigate={setActiveTab} />;
          case "darshan":
  return <DarshanDashboard onNavigate={setActiveTab} />;
        default:
          return <DashboardContent panelKey={baseKey} panelTitle={panel.title} onNavigate={setActiveTab} />;
      }
    }

    // C. Profile sub-sections
    if (PROFILE_SECTIONS[tab]) {
      return <VendorProfile initialSection={PROFILE_SECTIONS[tab]} />;
    }

    // D. Placeholder pages
    if (SIMPLE_PAGES[tab]) {
      const [title, description] = SIMPLE_PAGES[tab];
      return <SimplePremiumPage title={title} description={description} />;
    }

    // E. Real pages, warna dashboard
    return (
      PAGES[tab] || (
        <DashboardContent panelKey={baseKey} panelTitle={panel.title} onNavigate={setActiveTab} />
      )
    );
  };

  if (loading) {
    return (
      <div className="bmt-loader">
        <div className="bmt-loader-ring" />
        <p>Loading BirdMyTrip Partner Panel...</p>
      </div>
    );
  }

  const NavButton = ({ item }) => (
    <button
      className={`vx-item ${tab === item.id ? "active" : ""}`}
      onClick={() => setActiveTab(item.id)}
      title={item.label}
    >
      <span className="vx-icon">{item.icon}</span>
      <span className="vx-label">{item.label}</span>
    </button>
  );

  return (
    <div className="vx-app">
      <div className="vx-side">
        <div className="vx-brand-box">
          <div className="vx-brandmark">{panel.icon}</div>
          <div className="vx-brand-title"><strong>{panel.title}</strong><span>Vendor</span></div>
        </div>

        <div className="vx-nav">
          <div className="vx-section">Main menu</div>
          {panel.main.map((item) => <NavButton key={item.id} item={item} />)}

          <div className="vx-section">Help & Legal</div>
          {COMMON_VENDOR_MENU.map((item) => (
            <NavButton key={item.id} item={item} />
          ))}

          <div className="vx-section">Account</div>

          <button
            type="button"
            className={`vx-item vx-account-toggle ${
              String(activeTab).startsWith("profile_") ? "active" : ""
            }`}
            onClick={() => setAccountOpen((prev) => !prev)}
            aria-expanded={accountOpen}
          >
            <span className="vx-icon">{IC.user}</span>
            <span className="vx-label">My Profile</span>
            <span className={`vx-account-arrow ${accountOpen ? "expanded" : ""}`}>›</span>
          </button>

          {accountOpen && (
            <div className="vx-account-submenu">
              {ACCOUNT.filter(
                (item) => item.id.startsWith("profile_") && item.id !== "profile_personal"
              ).map((item) => (
                <NavButton key={item.id} item={item} />
              ))}
            </div>
          )}
        </div>

        <div className="vx-side-foot">
          <div className="vx-portal">
            <span className="vx-portal-icon">▮</span>
            <div><b>Vendor Portal</b><small>Manage your {panel.title.toLowerCase()} business</small></div>
          </div>
          <button className="vx-logout" onClick={logout}>
            <span className="vx-icon">↪</span><span className="vx-label">Logout</span>
          </button>
        </div>
      </div>

      <div className="vx-main-wrap">
        <div className="vx-top">
          <div className="vx-brand">
            <div className="vx-logo">bmt</div>
            <div className="vx-brand-text">
              <strong className="vx-name">{vendorName || "BirdMyTrip Partner"}</strong>
              <div className="vx-sub-line"><span className="vx-pill">{panel.title}</span><span>BirdMyTrip Verified Partner</span></div>
            </div>
          </div>
          <div className="vx-top-actions">
            <button className="vx-help" aria-label="Help">?</button>
            <button className="vx-user" onClick={() => setActiveTab("profile_personal")}>
              <span className="vx-avatar">{(vendorName || "V").charAt(0).toUpperCase()}</span>
              <span className="vx-user-text"><b>{vendorName || "Vendor"}</b><small>Partner</small></span>
            </button>
          </div>
        </div>

        <div className="vx-main">
          <div className="vx-content">
            <PageErrorBoundary resetKey={`${key}-${tab}`}>
              {renderContent()}
            </PageErrorBoundary>
          </div>
        </div>
      </div>
    </div>
  );
}

/* ==================== STAY SUBTYPE DASHBOARD (hostel, motel, lodge, ...) ==================== */

function StayDashboard({ serviceKey, onNavigate }) {
  const cfg = STAY_SUBTYPES[serviceKey];

  const name = useMemo(() => {
    try {
      const v = JSON.parse(localStorage.getItem("vendorUser") || "{}");
      return (
        v?.business?.businessName ||
        v?.businessName ||
        v?.companyName ||
        v?.name ||
        `Your ${cfg?.title || "Property"}`
      );
    } catch {
      return `Your ${cfg?.title || "Property"}`;
    }
  }, [cfg]);

  if (!cfg) return null;

  const t = {
    bookings: `${serviceKey}_bookings`,
    inventory: `${serviceKey}_inventory`,
    manage: `${serviceKey}_manage`,
    rooms: `${serviceKey}_rooms`,
  };

  const metrics = [
    { title: `Today's ${cfg.unit}`, value: "0", sub: `FOR LAST 7 DAYS : 0 ${cfg.unit.toUpperCase()}`, action: t.bookings },
    { title: "Today's Revenue", value: "₹ 0", sub: "FOR LAST 7 DAYS : ₹ 0", action: t.bookings },
    { title: "Occupancy Rate", value: "0%", sub: cfg.occupancy.toUpperCase(), action: t.inventory },
    { title: "Today's Check-ins", value: "0", sub: "FOR LAST 7 DAYS : 0 CHECK-INS", action: t.bookings },
  ];
  const setupTargets = [t.manage, t.rooms, t.inventory, t.manage];

  return (
    <div className="bmt-dashboard">
      <section className="bmt-performance-head">
        <div className="bmt-title-line">
          <h1>{cfg.title} Dashboard</h1>
          <span className="bmt-info-icon">?</span>
        </div>
        <p>{name} · Last updated just now</p>
      </section>

      <section className="bmt-analytics-banner">
        <div>
          <h2>{cfg.title} Analytics</h2>
          <p>{cfg.banner}</p>
        </div>
        <button onClick={() => onNavigate(t.manage)}>View All</button>
      </section>

      <section className="bmt-metrics-grid">
        {metrics.map((m) => (
          <article className="bmt-metric-card" key={m.title}>
            <h3>{m.title}</h3>
            <div className="bmt-metric-value">{m.value}</div>
            <p>{m.sub}</p>
            <button onClick={() => onNavigate(m.action)}>View More</button>
          </article>
        ))}
      </section>

      <section className="bmt-dashboard-bottom-grid">
        <article className="bmt-panel-card">
          <div className="bmt-card-header">
            <div><h3>{cfg.title} Setup</h3><p>Complete your {cfg.title.toLowerCase()} listing</p></div>
            <span className="bmt-new-badge">NEW</span>
          </div>
          <div className="bmt-action-list">
            {cfg.setup.map((label, i) => (
              <button key={label} onClick={() => onNavigate(setupTargets[i] || t.manage)}>
                <span>{label}</span><b>›</b>
              </button>
            ))}
          </div>
        </article>

        <article className="bmt-panel-card">
          <div className="bmt-card-header">
            <div><h3>Today's Snapshot</h3><p>Quick operational summary</p></div>
          </div>
          <div className="bmt-snapshot-grid">
            {cfg.snapshot.map((s) => (
              <div key={s}><strong>0</strong><span>{s}</span></div>
            ))}
          </div>
        </article>
      </section>
    </div>
  );
}

/* Khali naya page: jab tak asli component CUSTOM_PAGES mein add nahi hota */
function NewSubtypePage({ serviceKey, tabId, label }) {
  const cfg = STAY_SUBTYPES[serviceKey];
  return (
    <div className="bmt-premium-page">
      <Intro
        eyebrow={`${(cfg?.title || "").toUpperCase()} PARTNER`}
        title={label}
        text={`${cfg?.title || "Is service"} ka ${label} page abhi bana nahi hai.`}
      />
      <section className="bmt-form-card">
        <div className="bmt-empty-state">
          <div className="bmt-empty-icon">✦</div>
          <h3>{cfg?.title} · {label}</h3>
          <p>
            Is page ka component banao aur <code>CUSTOM_PAGES</code> mein <code>{tabId}</code> naam se add kar do.
          </p>
        </div>
      </section>
    </div>
  );
}

/* ==================== DASHBOARD (generic) ==================== */

function DashboardContent({ panelKey, panelTitle, onNavigate }) {
  const isStay = STAY_PANELS.includes(panelKey);
  const bookingTarget = BOOKING_TARGET[panelKey] || "dashboard";
  const inventoryTarget = INVENTORY_TARGET[panelKey] || "dashboard";
  const setupActions = SETUP_ACTIONS[panelKey] || SETUP_ACTIONS.default;
  const title = panelTitle || "";

  const metrics = isStay ? [
    { title: "Today's Room Nights", value: "0", sub: "FOR LAST 7 DAYS : 3 ROOM NIGHTS", action: bookingTarget },
    { title: "Today's Revenue", value: "₹ 0", sub: "FOR LAST 7 DAYS : ₹ 3,239", action: bookingTarget },
    { title: "Today's Average Selling Price", value: "₹ 0", sub: "FOR LAST 7 DAYS : ₹ 1,371", action: inventoryTarget },
    { title: "Today's Check-ins", value: "0", sub: "FOR LAST 7 DAYS : 3 CHECK-INS", action: bookingTarget },
  ] : [
    { title: "Today's Bookings", value: "0", sub: "FOR LAST 7 DAYS : 12 BOOKINGS", action: bookingTarget },
    { title: "Today's Revenue", value: "₹ 0", sub: "FOR LAST 7 DAYS : ₹ 8,920", action: bookingTarget },
    { title: "Active Listings", value: "8", sub: "CURRENTLY LIVE ON BIRDMYTRIP", action: inventoryTarget },
    { title: "Upcoming Operations", value: "5", sub: "NEXT 7 DAYS", action: bookingTarget },
  ];

  return (
    <div className="bmt-dashboard">
      <section className="bmt-performance-head">
        <div className="bmt-title-line">
          <h1>{title ? `${title} Performance Overview` : "Performance Overview"}</h1>
          <span className="bmt-info-icon">?</span>
        </div>
        <p>Last updated just now</p>
      </section>

      <section className="bmt-analytics-banner">
        <div>
          <h2>{isStay ? `${title || "Property"} Analytics` : "Business Analytics"}</h2>
          <p>See detailed analysis and past data for Revenue, Room Nights, Average Selling Price, Conversion, Bookings and more.</p>
        </div>
        <button onClick={() => onNavigate("analytics")}>View All</button>
      </section>

      <section className="bmt-metrics-grid">
        {metrics.map((m) => (
          <article className="bmt-metric-card" key={m.title}>
            <h3>{m.title}</h3>
            <div className="bmt-metric-value">{m.value}</div>
            <p>{m.sub}</p>
            <button onClick={() => onNavigate(m.action)}>View More</button>
          </article>
        ))}
      </section>

      {isStay && (
        <section className="bmt-dashboard-bottom-grid">
          <article className="bmt-panel-card">
            <div className="bmt-card-header">
              <div><h3>{title ? `${title} Setup` : "Property Setup"}</h3><p>Complete important property content</p></div>
              <span className="bmt-new-badge">NEW</span>
            </div>
            <div className="bmt-action-list">
              {setupActions.map(([target, label]) => (
                <button key={`${target}-${label}`} onClick={() => onNavigate(target)}>
                  <span>{label}</span><b>›</b>
                </button>
              ))}
            </div>
          </article>
          <article className="bmt-panel-card">
            <div className="bmt-card-header"><div><h3>Today's Snapshot</h3><p>Quick operational summary</p></div></div>
            <div className="bmt-snapshot-grid">
              <div><strong>0</strong><span>Pending</span></div>
              <div><strong>0</strong><span>Confirmed</span></div>
              <div><strong>0</strong><span>Cancelled</span></div>
              <div><strong>0</strong><span>Completed</span></div>
            </div>
          </article>
        </section>
      )}
    </div>
  );
}

/* ==================== PAGE COMPONENTS ==================== */

function Intro({ eyebrow, title, text, extra }) {
  return (
    <div className="bmt-section-intro">
      <div><span className="bmt-eyebrow">{eyebrow}</span><h2>{title}</h2><p>{text}</p></div>
      {extra}
    </div>
  );
}

function FormActions({ saveLabel }) {
  return (
    <div className="bmt-form-actions">
      <button className="bmt-secondary-btn">Save Draft</button>
      <button className="bmt-primary-btn">{saveLabel}</button>
    </div>
  );
}

function Field({ label, placeholder, type = "text" }) {
  return <div className="bmt-field-group"><label>{label}</label><input type={type} placeholder={placeholder} /></div>;
}

function SelectField({ label, options }) {
  return (
    <div className="bmt-field-group">
      <label>{label}</label>
      <select defaultValue=""><option value="" disabled>Select</option>{options.map((o) => <option key={o}>{o}</option>)}</select>
    </div>
  );
}

function PropertyMedia() {
  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);
  const [videoUrl, setVideoUrl] = useState("");
  const toItems = (event) =>
    Array.from(event.target.files || []).map((file) => ({ file, url: URL.createObjectURL(file), name: file.name }));

  return (
    <div className="bmt-premium-page">
      <Intro
        eyebrow="PROPERTY CONTENT"
        title="Images & Videos"
        text="Add high-quality property photos, room photos, exterior images, facilities, dining images and walkthrough videos."
        extra={<span className="bmt-completion-pill">Media completeness 0%</span>}
      />
      <div className="bmt-property-grid">
        <section className="bmt-form-card">
          <div className="bmt-form-card-head"><h3>Property Images</h3><p>Recommended: minimum 8 clear landscape photos.</p></div>
          <label className="bmt-upload-zone">
            <input type="file" accept="image/*" multiple onChange={(e) => setImages((p) => [...p, ...toItems(e)])} />
            <span className="bmt-upload-icon">＋</span>
            <strong>Upload property images</strong>
            <small>JPG, PNG, WEBP • Front view, rooms, lobby, washroom, dining and facilities</small>
          </label>
          {images.length > 0 && (
            <div className="bmt-media-grid">
              {images.map((img, i) => (
                <div className="bmt-media-item" key={`${img.name}-${i}`}>
                  <img src={img.url} alt={img.name} />
                  <button onClick={() => setImages((p) => p.filter((_, x) => x !== i))}>Remove</button>
                </div>
              ))}
            </div>
          )}
        </section>

        <section className="bmt-form-card">
          <div className="bmt-form-card-head"><h3>Property Videos</h3><p>Upload walkthrough videos or add a video URL.</p></div>
          <label className="bmt-upload-zone compact">
            <input type="file" accept="video/*" multiple onChange={(e) => setVideos((p) => [...p, ...toItems(e)])} />
            <span className="bmt-upload-icon">▶</span>
            <strong>Upload property video</strong>
            <small>MP4 / WEBM recommended</small>
          </label>
          <div className="bmt-field-group">
            <label>Video URL</label>
            <div className="bmt-inline-input">
              <input value={videoUrl} onChange={(e) => setVideoUrl(e.target.value)} placeholder="https://youtube.com/... or property video URL" />
              <button type="button">Add URL</button>
            </div>
          </div>
          {videos.length > 0 && (
            <div className="bmt-media-grid video-grid">
              {videos.map((v, i) => (
                <div className="bmt-media-item" key={`${v.name}-${i}`}>
                  <video src={v.url} controls />
                  <button onClick={() => setVideos((p) => p.filter((_, x) => x !== i))}>Remove</button>
                </div>
              ))}
            </div>
          )}
        </section>
      </div>
    </div>
  );
}

function PropertyAmenities() {
  const amenities = [
    "Free Wi-Fi", "Parking", "Air Conditioning", "Restaurant", "Room Service", "Swimming Pool", "Gym", "Spa",
    "Airport Transfer", "24x7 Front Desk", "Power Backup", "Lift / Elevator", "Laundry", "Pet Friendly",
    "Wheelchair Accessible", "EV Charging",
  ];
  const [selected, setSelected] = useState([]);
  const toggle = (name) => setSelected((p) => (p.includes(name) ? p.filter((x) => x !== name) : [...p, name]));

  return (
    <div className="bmt-premium-page">
      <Intro eyebrow="PROPERTY INFORMATION" title="Amenities & Facilities" text="Select all facilities available at the property." />
      <section className="bmt-form-card">
        <div className="bmt-check-grid">
          {amenities.map((item) => (
            <label className={`bmt-check-card ${selected.includes(item) ? "selected" : ""}`} key={item}>
              <input type="checkbox" checked={selected.includes(item)} onChange={() => toggle(item)} />
              <span>{item}</span>
            </label>
          ))}
        </div>
        <FormActions saveLabel="Save Amenities" />
      </section>
    </div>
  );
}

function PropertyLocation() {
  return (
    <div className="bmt-premium-page">
      <Intro eyebrow="PROPERTY INFORMATION" title="Location & Contact" text="Keep the exact map location and guest-facing contact details updated." />
      <section className="bmt-form-card">
        <div className="bmt-form-grid">
          <Field label="Address line 1" placeholder="Property address" />
          <Field label="Address line 2" placeholder="Area / Landmark" />
          <Field label="City" placeholder="City" />
          <Field label="State / Province" placeholder="State / Province" />
          <Field label="Postal Code" placeholder="Postal code" />
          <Field label="Country" placeholder="Country" />
          <Field label="Latitude" placeholder="e.g. 27.4924" />
          <Field label="Longitude" placeholder="e.g. 77.6737" />
          <Field label="Property Phone" placeholder="+91..." />
          <Field label="Property Email" placeholder="property@example.com" />
        </div>
        <div className="bmt-map-placeholder"><span>Map preview</span><small>Connect Google Maps / Mapbox later with your API key.</small></div>
        <FormActions saveLabel="Save Location" />
      </section>
    </div>
  );
}

function PropertyPolicies() {
  return (
    <div className="bmt-premium-page">
      <Intro eyebrow="PROPERTY INFORMATION" title="Policies & House Rules" text="Define check-in, check-out, cancellation, child and guest rules." />
      <section className="bmt-form-card">
        <div className="bmt-form-grid">
          <Field label="Check-in from" type="time" />
          <Field label="Check-out until" type="time" />
          <SelectField label="Children allowed?" options={["Yes", "No", "On request"]} />
          <SelectField label="Pets allowed?" options={["No", "Yes", "On request"]} />
          <SelectField label="Smoking" options={["Not allowed", "Designated area only", "Allowed"]} />
          <SelectField label="Unmarried couples" options={["Allowed", "Not allowed", "Subject to ID verification"]} />
        </div>
        <div className="bmt-field-group"><label>Cancellation Policy</label><textarea rows="5" placeholder="Describe cancellation and no-show rules..." /></div>
        <div className="bmt-field-group"><label>House Rules</label><textarea rows="5" placeholder="Add important guest rules..." /></div>
        <FormActions saveLabel="Save Policies" />
      </section>
    </div>
  );
}

function PropertyDocuments() {
  const docs = ["Business Registration", "Tax Registration", "Property License", "Owner / Authorized ID", "Bank Proof", "Fire / Safety Certificate"];
  return (
    <div className="bmt-premium-page">
      <Intro eyebrow="VERIFICATION" title="Documents & Verification" text="Upload and track documents required to keep your property live." />
      <section className="bmt-form-card">
        <div className="bmt-document-list">
          {docs.map((doc) => (
            <div className="bmt-document-row" key={doc}>
              <div><strong>{doc}</strong><span>Not uploaded</span></div>
              <label className="bmt-upload-small">Upload<input type="file" /></label>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

function PropertyHighlights() {
  const [highlights, setHighlights] = useState(["Near major attractions", "Family friendly"]);
  const [value, setValue] = useState("");
  const add = () => {
    const next = value.trim();
    if (!next) return;
    setHighlights((p) => [...p, next]);
    setValue("");
  };

  return (
    <div className="bmt-premium-page">
      <Intro eyebrow="CONTENT QUALITY" title="Highlights & USPs" text="Add the strongest reasons a guest should choose your property." />
      <section className="bmt-form-card">
        <div className="bmt-field-group">
          <label>Property short description</label>
          <textarea rows="6" placeholder="Write a clear, premium guest-facing property description..." />
        </div>
        <div className="bmt-field-group">
          <label>Add highlight</label>
          <div className="bmt-inline-input">
            <input value={value} onChange={(e) => setValue(e.target.value)} placeholder="e.g. 2 minutes from the beach" />
            <button type="button" onClick={add}>Add</button>
          </div>
        </div>
        <div className="bmt-chip-wrap">
          {highlights.map((item, i) => (
            <span className="bmt-chip" key={`${item}-${i}`}>
              {item}
              <button onClick={() => setHighlights((p) => p.filter((_, x) => x !== i))}>×</button>
            </span>
          ))}
        </div>
        <FormActions saveLabel="Save Content" />
      </section>
    </div>
  );
}

function AnalyticsPage() {
  const cards = [["Revenue", "₹0", "+0%"], ["Room Nights", "0", "+0%"], ["Average Selling Price", "₹0", "+0%"], ["Conversion", "0%", "+0%"]];
  return (
    <div className="bmt-premium-page">
      <Intro eyebrow="PERFORMANCE" title="Analytics" text="Property performance overview for bookings, revenue and conversion." />
      <div className="bmt-analytics-cards">
        {cards.map(([title, value, trend]) => (
          <article key={title}><span>{title}</span><strong>{value}</strong><small>{trend} vs previous period</small></article>
        ))}
      </div>
      <section className="bmt-form-card">
        <div className="bmt-chart-placeholder"><strong>Performance chart</strong><span>Connect this section to your analytics API data.</span></div>
      </section>
    </div>
  );
}

function SimplePremiumPage({ title, description }) {
  return (
    <div className="bmt-premium-page">
      <Intro eyebrow="BIRDMYTRIP PARTNER" title={title} text={description} />
      <section className="bmt-form-card">
        <div className="bmt-empty-state">
          <div className="bmt-empty-icon">✦</div>
          <h3>{title}</h3>
          <p>Frontend section is ready. Connect this screen to the matching BirdMyTrip backend API when available.</p>
          <button className="bmt-primary-btn">Get Started</button>
        </div>
      </section>
    </div>
  );
}